export default {
    key: 'value',
    route: {
        dashboard: 'Panel',
        article: 'Artigos',
    },
    month: {
        jan: 'Xaneiro',
        feb: 'Febreiro',
        mar: 'Marzo',
        apr: 'Abril',
        may: 'Maio',
        jun: 'Xuño',
        jul: 'Xullo',
        aug: 'Agosto',
        sep: 'Setembro',
        oct: 'Outubro',
        nov: 'Novembro',
        dec: 'Decembro',
    },
    week: {
        mon: 'Lu',
        tue: 'Ma',
        wed: 'Mé',
        thu: 'Xo',
        fri: 'Ve',
        sat: 'Sá',
        sun: 'Do',
    },
    navbar: {
        logOut: 'Pechar sesión',
        myProfile: 'O meu perfil',
        termsConditions: 'Termos e condicións',
    },
    login: {
        title: 'Inicio de sesión: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        logIn: 'Iniciar sesión',
        username: 'Nome de usuario',
        password: 'Contrasinal',
        loginForm: {
            header: 'Dámoslle a benvida a ##COMPANY_BRAND_NAME##',
        },
        qrCode: {
            header: 'Introduza o código do seu autenticador.',
            subheader: 'Introduza o código de 6 díxitos para continuar',
            placeholderSecurityCode: 'Introduza aquí o código de seguranza',
        },
        forgotPassword: {
            header: 'Esqueceu o seu contrasinal?',
            subheader:
                'Introduza o seu enderezo de correo electrónico a continuación e enviarémoslle unha mensaxe para restablecer o contrasinal',
            placeholderEmail: 'Introduza o seu enderezo de correo electrónico',
        },
        resetPassord: {
            header: 'Restableza o seu contrasinal.',
            subheader: 'Introduza o código que lle enviamos por correo electrónico e restableza o seu contrasinal.',
            placeholder: {
                code: 'Introduza o seu código',
                newPassWord: 'Introduza o seu enderezo de correo electrónico',
                confirmPassWord: 'Restableza o seu contrasinal',
            },
            success: 'O seu contrasinal restableceuse correctamente.',
        },
        button: {
            login: 'Iniciar sesión',
            forgotPassword: 'Esqueceu o contrasinal?',
            resetMyPassword: 'Restablecer o meu contrasinal',
            submitMyPassword: 'Gardar o novo contrasinal',
            back: 'Volver',
            instavolt: '##COMPANY_BRAND_NAME##',
        },
        label: {
            rememberMe: 'Lembrarme',
            password: 'Contrasinal',
            userId: 'ID de usuario',
            copyright: 'Dereitos de autor ##COMPANY_BRAND_NAME##.',
            showPassword: 'Mostrar contrasinal',
            hidePassword: 'O importe debe ser maior/menor que 1',
        },
        errors: {
            email: {
                email: 'Introduza un enderezo de correo electrónico válido.',
                required: 'Introduza o seu correo electrónico.',
            },
            password: {
                required: 'Introduza o seu contrasinal.',
                max: 'O contrasinal debe ter polo menos 8 caracteres',
            },
            securityCode: {
                required: 'Introduza o seu código de seguranza.',
                max: 'O código de seguranza debe ter polo menos 6 caracteres',
            },
            verificationCodeInvalid: 'Código de verificación non válido.',
            generalError: 'Erro ao procesar a súa solicitude.',
            incorrectCredentials: 'Nome de usuario ou contrasinal incorrectos.',
            defaultPasswordExpired: 'O seu contrasinal caducou e debe restablecelo un administrador.',
            inValidEmailAddress: 'O enderezo de correo electrónico non é válido.',
            securityCodeInvalid: 'Código de seguranza non válido.',
            verificationCodeFormat: 'Introduza o código de verificación de 6 díxitos.',
            passwordFormat:
                'O contrasinal debe ter 15 caracteres, con polo menos unha letra maiúscula, minúscula, carácter especial e número.',
            confirmPasswordMatch: 'O contrasinal e o contrasinal de reconfirmación non coinciden.',
            common: 'Produciuse un erro, ténteo de novo.',
        },
        toast: {
            error: 'Produciuse un erro, ténteo de novo.',
        },
    },
    dashboard: {
        title: 'Inicio: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Panel',
        formtitle: 'Validación de formularios',
        label: {
            pending: 'Pendente',
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito dispoñible',
            unbilledAmount: 'Importe non facturado',
            filter: 'Filtrar',
            reportTags: 'Etiquetas do informe',
            driverGroup: 'Grupos de condutores',
            selectDriverGroup: 'Seleccionar grupos de condutores',
            selectTags: 'Seleccionar etiquetas',
            dateRange: 'Intervalo de datas',
            month: 'Mes',
            year: 'Ano',
            day: 'Día',
            week: 'Semana',
            userSessionTitle: 'Sesións de condutores',
            userSessions: 'Sesións de condutores',
            expenseTitle: 'Suma de gastos',
            expense: 'Gasto',
            energyTitle: 'Suma de enerxía (kWh)',
            enrgy: 'Enerxía',
            averageTransationTitle: 'Media de transaccións',
            transaction: 'Transacción',
            creditLimit: 'Límite de crédito',
            totalDriverAccounts: 'Total de contas de condutores',
            enabled: 'Activado',
            disabled: 'Desactivado',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Limpar',
        },
        cpoType: {
            Both: 'Ambos',
            Local: 'Local',
            International: 'Internacional',
        },
    },
    permission: {
        createArticle: 'Engadir artigo',
        editArticle: 'Editar artigo',
        save: 'Gardar',
        confirm: 'Está seguro/a?',
        cancel: 'Cancelar',
        update: 'Actualizar',
    },
    table: {
        pagination: {
            prev: 'Anterior',
            nrev: 'Seguinte',
            showing: 'Mostrando',
        },
        data: {
            noData: 'Non se atoparon datos.',
        },
    },
    article: {
        title: 'Xestionar artigo',
        id: 'ID do artigo',
        date: 'Data',
        tabletitle: 'Título',
        author: 'Autor',
        reviewer: 'Revisor',
        actions: 'Accións',
        saveMessage: 'Artigo gardado correctamente',
        updateMessage: 'Artigo actualizado correctamente',
        deleteMessage: 'Artigo eliminado correctamente',
    },
    user: {
        title: 'Usuarios: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        user: 'Usuarios',
        manageUser: 'Xestionar usuario',
        placeholder: {
            name: 'Nome',
            email: 'Enderezo de correo electrónico',
            phoneNo: 'Número de teléfono',
            firstName: 'Nome',
            lastName: 'Apelidos',
            userGroup: 'Grupos de usuarios',
            userRoles: 'Funcións dos usuarios',
            Organisation: 'Organización',
            select: 'Seleccionar estado',
            selectOrganisation: 'Seleccionar organización',
            selectUserGroup: 'Seleccionar grupo de usuarios',
            languagePreference: 'Preferencias de idioma',
        },
        label: {
            firstName: 'Nome',
            lastName: 'Apelidos',
            email: 'Correo electrónico',
            phoneNo: 'Número de teléfono',
            optional: '(Opcional)',
            userGroups: 'Grupos de usuarios',
            userRoles: 'Funcións dos usuarios',
            Organisation: 'Organización',
            createdDate: 'Data de creación',
            languagePreference: 'Preferencias de idioma',
            id: 'Id',
            action: 'Acción',
            status: 'Estado',
            name: 'Nome',
            delete: 'Eliminar',
            enable: 'Activar',
            all: 'Todo',
            disable: 'Desactivar',
            enabled: 'Activado',
            disabled: 'Desactivado',
            pending: 'Pendente',
            reset2FA: 'Restablecer 2FA',
            deleted: 'Eliminado',
            lastLoginDate: 'Data da última conexión',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            add: 'Engadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            sendEmail: 'Enviar correo electrónico',
            reset2FA: 'Restablecer 2FA',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            sendMailConfirmMessage: 'Seguro que quere enviar o correo electrónico?',
            mailSentSuccessMessage: 'Correo electrónico enviado correctamente.',
            reset2FAConfirmMesage: 'Seguro que quere restablecer 2FA para este usuario?',
        },
        errors: {
            email: {
                required: 'Introduza o enderezo de correo electrónico',
                email: 'Introduza un enderezo de correo electrónico válido',
            },
            firstName: {
                required: 'Introduza o nome',
                valid: 'Introduza un nome válido',
            },
            lastName: {
                required: 'Introduza os apelidos',
                valid: 'Introduza uns apelidos válidos',
            },
            phoneNo: {
                required: 'Introduza o número de teléfono',
                match: 'Introduza un número de teléfono válido',
            },
            userGroups: {
                required: 'Seleccione polo menos un grupo de usuarios',
            },
            organization: {
                required: 'Seleccione unha organización',
            },
        },
    },
    userGroup: {
        title: 'Grupos de usuarios: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        manageUserGroup: 'Xestionar grupo de usuarios',
        users: 'Usuarios',
        header: 'Grupos de usuarios',
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            edit: 'Editar',
            delete: 'Eliminar',
            save: 'Gardar',
            cancel: 'Cancelar',
            yes: 'Si',
            no: 'Non',
            action: 'Acción',
            add: 'Engadir',
            back: 'Volver',
            enable: 'Activar',
            disable: 'Desactivar',
            permission: 'Permiso de acceso',
        },
        placeholder: {
            groupName: 'Nome do grupo',
            users: 'Seleccionar usuarios',
            select: 'Seleccionar estado',
            organisation: 'Seleccionar organización',
        },
        message: {
            deleteConfirmMesageForOrganistion:
                'Ao eliminar este grupo de organización, eliminaremos a asociación de grupo para unha organización concreta, seguro de que desexa continuar?',
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
        },
        label: {
            id: 'Id',
            name: 'Nome',
            description: 'Descrición',
            Organisation: 'Organización',
            createdBy: 'Creado por',
            status: 'Estado',
            modifiedBy: 'Modificado por',
            createdDate: 'Data de creación',
            modifiedDate: 'Data de modificación',
            action: 'Acción',
            groupName: 'Nome do grupo',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            phoneNo: 'Número de teléfono',
            email: 'Enderezo de correo electrónico',
            groupAccess: 'Acceso de grupo',
            selectUsers: 'Seleccionar usuarios',
            enabled: 'Activado',
            disabled: 'Desactivado',
            yes: 'Si',
            no: 'Non',
        },
        form: {
            groupName: {
                label: 'Nome do grupo',
                placeholder: 'Introduza o nome do grupo',
            },
            description: {
                label: 'Descrición',
                placeholder: 'Introducir descrición',
            },
            Organisation: {
                label: 'Organización',
            },
        },
        errors: {
            groupName: {
                required: 'Introduza o nome do grupo',
                valid: 'Introduza un nome de grupo válido',
                max: 'Máximo 50 caracteres permitidos',
            },
            description: {
                max: 'Máximo 255 caracteres permitidos',
            },
            userList: {
                required: 'Seleccione polo menos un usuario',
            },
        },
        permission: {
            header: 'Permiso',
            label: {
                module: 'Módulo',
                subModule: 'Submódulo',
                action: 'Acción',
            },
        },
    },
    transactions: {
        headerTitle:
            'Transaccións de condutores - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        title: 'Transaccións de condutores',
        transaction: 'Transacción',
        columns: {
            amount: 'Importe',
            location: 'Localización',
            date: 'Data',
            milesAdded: 'Quilómetros engadidos',
            time: 'Hora',
            cost: 'Custo',
            energy: 'Enerxía',
            action: 'Acción',
            remark: 'Observacións',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Pechando',
            transaction: 'ID de transacción',
            name: 'Nome',
            type: 'Tipo',
            federatedAccount: 'Tipo de conta federada',
            reference_id: 'ID de referencia',
        },
        form: {
            charge: 'Cargando',
            payment: 'Pagamento',
            month: 'Mes',
        },
        label: {
            exportAll: 'Exportar todo',
            driver: 'Condutor',
            vehicle: 'Vehículo',
            cardPayment: 'Pagamento con tarxeta',
            referralBonus: 'Bonificación por recomendación',
            rewards: 'Recompensas',
            transactionDetails: 'Detalles da transacción',
            transaction_id: 'ID de transacción',
            fullName: 'Nome e apelidos',
            email: 'Correo electrónico',
            phone_number: 'Número de teléfono',
            viewFailedPayments: 'Ver erros de pagamento',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Volver',
        },
        placeholder: {
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            name: 'Nome',
            chargingStation: 'Estación de carga',
            selectType: 'Seleccionar tipo',
            transaction: 'ID de transacción',
            reference_id: 'ID de referencia',
        },
        message: {
            noDataToExport: 'Non hai datos para exportar.',
            error: {
                common: 'Produciuse un erro. Ténteo de novo',
            },
        },
    },
    driver: {
        title: 'Condutores: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Condutores',
        manageDriver: 'Xestionar condutor',
        startCharge: 'Iniciar carga remota',
        activities: 'Actividades',
        detail: 'Datos do condutor',
        address_detail: 'Enderezo',
        billing_address_detail: 'Enderezo de facturación',
        chargeDetails: 'Detalles da carga',
        debtLetterHistory: 'Historial de cartas de débeda',
        note: 'Nota: Se a recompensa actual do condutor é diferente á nova promoción, os seus voltios actuais caducarán.',
        charityAdded: 'Doazón benéfica engadida',
        cd: 'cd',
        placeholder: {
            name: 'Nome',
            email: 'Enderezo de correo electrónico',
            firstName: 'Nome',
            lastName: 'Apelidos',
            payment_card: '4 últimos díxitos da tarxeta de pagamento',
            select: {
                status: 'Seleccionar estado',
                account_type: 'Seleccionar tipo de conta',
                payment_type: 'Seleccionar tipo de pagamento',
                driver_groups: 'Seleccionar grupos de condutores',
                driver_tags: 'Seleccionar etiquetas',
                organization: 'Seleccionar organización',
                promotion: 'Seleccionar promoción',
            },
            driverGroup: 'Grupos de condutores',
            organization: 'Organización',
            account_type: 'Tipo de conta',
            payment_type: 'Tipo de pagamento',
            referral_code: 'Código de recomendación',
            driver_tags: 'Etiquetas',
            address: 'Liña 1 de enderezo',
            address2: 'Liña 2 de enderezo',
            city: 'Cidade',
            county: 'Condado',
            postal_code: 'Código postal',
            billing_address: 'Liña 1 de enderezo',
            billing_address2: 'Liña 2 de enderezo',
            billing_city: 'Cidade',
            billing_county: 'Condado',
            billing_postal_code: 'Código postal',
            promotion: 'Promocións',
            currentDriverPromotion: 'Promoción actual',
            driverPromotionJoinDate: 'Data de incorporación',
            chargeLocation: 'Localización',
            chargeStation: 'Estación',
            connector: 'Conector',
            limitedKWH: 'KWh limitados:',
            confirmationNote:
                'Por seguranza da conta, confirme o nome, os apelidos, a liña 1 do enderezo e o código postal de cada condutor antes de iniciar a carga remota. Marque a caixa despois da confirmación do cliente',
            rfidCard: 'Tarxeta RFID',
            confirmationNoteFleet: 'Confirme este contrasinal co condutor: ',
            vehicle_number: 'Número de vehículo',
            api_url: 'URL da API',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            publicRFID: 'ID de tarxeta RFID pública',
            languagePreference: 'Preferencias de idioma',
            searchAddress: 'Enderezo',
        },
        label: {
            firstName: 'Nome',
            lastName: 'Apelidos',
            email: 'Correo electrónico',
            group: 'Grupo',
            driverGroups: 'Grupos de condutores',
            driver_tags: 'Etiquetas',
            organization: 'Organización',
            payment_type: 'Tipo de pagamento',
            referral_code: 'Código de recomendación',
            createdDate: 'Data de creación',
            id: 'Id',
            action: 'Acción',
            status: 'Estado',
            account_type: 'Tipo de conta',
            type: 'Tipo',
            name: 'Nome',
            delete: 'Eliminar',
            enable: 'Activar',
            all: 'Todo',
            disable: 'Desactivar',
            enabled: 'Activado',
            disabled: 'Desactivado',
            cancelled: 'Cancelado',
            deleted: 'Eliminado',
            address: 'Enderezo',
            address2: 'Liña 2 de enderezo',
            city: 'Cidade',
            county: 'Condado',
            postal_code: 'Código postal',
            billing_address: 'Liña 1 de enderezo',
            billing_address2: 'Liña 2 de enderezo',
            billing_city: 'Cidade',
            billing_county: 'Condado',
            billing_postal_code: 'Código postal',
            promotion: 'Promocións',
            expired: ' - Caducado',
            currentDriverPromotion: 'Promoción actual',
            driverPromotionJoinDate: 'Data de incorporación',
            vehicleNumber: 'Número de vehículo',
            paymentCard: 'Tarxeta de pagamento',
            cardType: 'Tipo de tarxeta',
            cardNumber: 'N.º de tarxeta (4 últimos díxitos)',
            cardTitle: 'Título da tarxeta',
            cardExpiry: 'Data de caducidade da tarxeta',
            paymentServiceProvider: 'Fornecedor de servizos de pagamento',
            viewReferral: 'Ver recomendación',
            referralDetails: 'Detalles da recomendación',
            referrer_name: 'Nome do recomendante',
            referral_name: 'Nome da recomendación',
            referral_bonus: 'Bonificación por recomendación',
            referralBonusStatus: 'Estado da bonificación por recomendación',
            referee_Name: 'Nome do recomendado',
            noRecords: 'Non hai rexistros para mostrar',
            noReferralsMessage: 'Non hai recomendacións',
            referrerName: 'Nome do recomendante do recomendado: ',
            referralCode: 'Código de recomendación do recomendante:',
            noReferrerMessage: 'Non hai recomendante',
            current_balance: 'Saldo actual',
            referral_balance: 'Saldo de recomendación',
            account_balance: 'Saldo da conta',
            rewards_balance: 'Saldo de recompensas',
            balanceDetails: 'Detalles do saldo',
            federated_account_type: 'Tipo de conta federada',
            pending: 'Pendente',
            rfidCard: 'Tarxeta RFID',
            startCharge: 'Iniciar carga remota',
            chargeLocation: 'Localización',
            chargeStation: 'Estación',
            connector: 'Conector',
            limitedKWH: 'KWh limitados:',
            confirmationNote:
                'Por seguranza da conta, confirme o nome, os apelidos, a liña 1 do enderezo e o código postal de cada condutor antes de iniciar a carga remota. Marque a caixa despois da confirmación do cliente',
            fullName: 'Nome e apelidos',
            phoneNo: 'Número de teléfono',
            confirmationNoteFleet: 'Confirme este contrasinal co condutor: ',
            chargingStartedMessage: 'Solicitude de inicio de carga remota realizada con éxito',
            resetPassword: 'Restablecer contrasinal',
            password: 'Contrasinal',
            disablePaymentCard: 'Desactivar tarxeta de pagamento',
            requestedData: 'Datos solicitados',
            apiURL: 'API',
            viewData: 'Ver datos',
            deletionEmailSent: 'Correo electrónico de eliminación de conta enviado',
            yes: 'Si',
            onstop: 'En suspensión',
            badDebtor: 'Debedor moroso',
            available: 'Dispoñible',
            languagePreference: 'Preferencias de idioma',
            fakeAccount: 'Conta falsa',
            addNotes: 'Engadir notas',
            newNote: 'Nova nota',
            addNote: 'Engadir nota',
            existingNotes: 'Notas existentes',
            viewNotes: 'Ver notas',
            notes: 'Notas',
            financialDetails: 'Datos financeiros',
            uniqueID: 'ID único',
            dateGenerated: 'Data de creación',
            debtValue: 'Valor da débeda',
            letterTemplate: 'Modelo de carta utilizado',
            lastCardValidationDate: 'Última data de validación da tarxeta',
        },
        account_type: {
            driver: 'Condutor',
            vehicle: 'Vehículo',
        },
        payment_type: {
            credit_account: 'Conta de crédito',
            prepayment_account: 'Conta de prepagamento',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            sendEmail: 'Enviar correo electrónico',
            viewTransactions: 'Ver transaccións',
            close: 'Pechar',
            startCharge: 'Iniciar carga remota',
            startChargeBtn: 'Carga inicial',
            resetPassword: 'Restablecer contrasinal',
            submit: 'Enviar',
            amendBalance: 'Modificar saldo',
            viewActivities: 'Ver actividades',
            premiumSubscriptions: 'Subscricións Premium',
            markAsFake: 'Marcar como conta falsa',
            addNotes: 'Engadir notas',
            debtLetterHistory: 'Historial de cartas de débeda',
            enableReferralCode: 'Activar código de referencia',
            disableReferralCode: 'Desactivar código de referencia',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            sendMailConfirmMessage: 'Seguro que quere enviar o correo electrónico?',
            mailSentSuccessMessage: 'Correo electrónico enviado correctamente.',
            resetPasswordConfirmMesage: 'Seguro que quere restablecer o contrasinal para este usuario?',
            deleteDriverConfirmMesage: 'Seguro que quere eliminar a conta deste condutor?',
            markAsFakeConfirmMessage:
                'Desexa marcar esta conta de condutor como falsa? É un proceso unidireccional no que se elimina a información.',
            enableReferralCodeConfirmMesage: 'Seguro que quere activar o código de recomendación para este condutor?',
            disableReferralCodeConfirmMesage:
                'Seguro que quere desactivar o código de recomendación para este condutor?',
        },
        errors: {
            driverGroups: {
                required: 'Seleccione polo menos un grupo de condutores',
            },
            organization: {
                required: 'Seleccione unha organización',
            },
            tag: {
                invalid_fromat: 'Caracteres non válidos na etiqueta',
            },
            fullName: {
                valid: 'Introduza un nome válido',
            },
            phoneNo: {
                match: 'Introduza un número de teléfono válido',
            },
            email: {
                required: 'Introduza o enderezo de correo electrónico',
                email: 'Introduza un enderezo de correo electrónico válido',
            },
            password: {
                passwordFormat:
                    'O contrasinal debe ter máis de 10 caracteres, con polo menos unha letra maiúscula, unha letra minúscula, un carácter especial e un número.',
            },
        },
    },
    driverGroup: {
        title: 'Grupos de condutores: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        titleFleet: 'Grupos: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        manageDriverGroup: 'Xestionar grupo de condutores',
        manageDriverGroupFleet: 'Xestionar grupo',
        driversList: 'Condutores',
        driversListFleet: 'Condutores/vehículos',
        header: 'Grupos de condutores',
        headerFleet: 'Grupos',
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            edit: 'Editar',
            delete: 'Eliminar',
            save: 'Gardar',
            cancel: 'Cancelar',
            yes: 'Si',
            no: 'Non',
            action: 'Acción',
            add: 'Engadir',
            back: 'Volver',
            enable: 'Activar',
            disable: 'Desactivar',
        },
        placeholder: {
            groupName: 'Nome do grupo',
            drivers: 'Seleccionar condutores',
            driversFleet: 'Seleccionar condutores/vehículos',
            select: 'Seleccionar estado',
            selectType: 'Seleccionar tipo',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
        },
        label: {
            id: 'Id',
            name: 'Nome',
            description: 'Descrición',
            organization: 'Organización',
            createdBy: 'Creado por',
            status: 'Estado',
            modifiedBy: 'Modificado por',
            createdDate: 'Data de creación',
            modifiedDate: 'Data de modificación',
            action: 'Acción',
            groupName: 'Nome do grupo',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            phoneNo: 'Número de teléfono',
            email: 'Enderezo de correo electrónico',
            groupAccess: 'Acceso de grupo',
            selectDrivers: 'Seleccionar condutores',
            selectDriversFleet: 'Seleccionar condutores/vehículos',
            enabled: 'Activado',
            disabled: 'Desactivado',
            yes: 'Si',
            no: 'Non',
            vehicle_number: 'Vehículo n.º',
            type: 'Tipo',
            updateDriverAssociation: 'Actualizar a asociación de condutores',
            addToThisGroup: 'Engadir a este grupo',
            cancel: 'Cancelar',
        },
        form: {
            groupName: {
                label: 'Nome do grupo',
                placeholder: 'Introduza o nome do grupo',
            },
            description: {
                label: 'Descrición',
                placeholder: 'Introducir descrición',
            },
        },
        errors: {
            groupName: {
                required: 'Introduza o nome do grupo',
                valid: 'Introduza un nome de grupo válido',
                max: 'Máximo 50 caracteres permitidos',
            },
            description: {
                max: 'Máximo 255 caracteres permitidos',
            },
            driverList: {
                required: 'Seleccione polo menos un condutor',
                requiredfleet: 'Seleccione polo menos un condutor/vehículo',
            },
            spendLimit: {
                valid: 'Introduza polo menos un valor límite de gasto',
            },
        },
    },
    vat: {
        title: 'IVE: ##COMPANY_BRAND_NAME##',
        vat: 'IVE',
        manageVat: 'Xestionar IVE',
        label: {
            name: 'Nome',
            description: 'Descrición',
            rate: 'Taxa',
            createdDate: 'Data de creación',
            action: 'Acción',
            status: 'Estado',
            disabled: 'Desactivado',
            enabled: 'Activado',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            defaultVAT: 'IVE predefinido',
            yes: 'Si',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            setDefaultConfirmMesage: 'Seguro que quere establecer este IVE como predefinido?',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            add: 'Engadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            setDefaultVAT: 'establecer como predefinido',
        },
        placeholder: {
            select: 'Seleccionar estado',
            name: 'Nome',
            description: 'Descrición',
            rate: 'Taxa',
        },
        errors: {
            name: {
                valid: 'Introduza un nome válido.',
            },
            rate: {
                max: 'A taxa non pode ser superior a 100',
                min: 'A taxa non pode ser inferior a 0',
                number: 'A taxa debe ser un número',
            },
            description: {
                valid: 'Introduza unha descrición válida',
            },
        },
    },
    confirmBox: {
        button: {
            yes: 'Si',
            no: 'Non',
            proceed: 'Continuar',
            cancel: 'Cancelar',
        },
    },
    tag: {
        title: 'Etiquetas: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        tag: 'Etiquetas',
        manageUser: 'Xestionar usuarios',
        placeholder: {
            name: 'Nome da etiqueta',
            select: 'Seleccionar',
        },
        label: {
            name: 'Nome da etiqueta',
            driver_count: 'Reconto de condutores',
            charge_location_count: 'Reconto de localizacións de carga',
            action: 'Acción',
            delete: 'Eliminar',
            editHeader: 'Editar etiqueta',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            add: 'Engadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
        },
        message: {
            deleteConfirmMesage:
                'A etiqueta eliminarase de todos os condutores asociados e da localización de carga. Seguro que quere eliminar?',
        },
        errors: {
            name: 'Caracteres non válidos na etiqueta',
        },
    },
    chargeStation: {
        title: 'Estacións de carga: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        chargeStations: 'Estacións de carga',
        manageVat: 'Xestionar estación de carga',
        label: {
            modifiedDate: 'Data de modificación',
            importChargeStationHeader: 'Importar estación de carga',
            csvFile: 'Ficheiro CSV',
            manageAmenities: 'Xestionar servizos',
            chargePoint: 'Punto de carga',
            allLocations: 'Todas as localizacións',
            assignedLocation: 'Localizacións asignadas',
            unassignedLocation: 'Localizacións sen asignar',
            chargeLocation: {
                cp_id: 'CP-Id',
                type: 'Tipo',
                name: 'Nome',
                locationName: 'Nome da localización',
                address: 'Enderezo',
                city: 'Cidade',
                postal_code: 'Código postal',
                chargePoint: 'Punto de carga',
                appliesToOrg: 'Aplícase á organización',
                associatedTariff: 'Tarifa asociada',
                associatedPromotion: 'Promoción asociada',
                gmbLocationId: 'ID de localización de GMB',
            },
            chargeStation: {
                uid: 'UId',
                evse_id: 'ID EVSE',
                status: 'Estado',
                physicalReference: 'Referencia física',
                city: 'Cidade',
                postal_code: 'Código postal',
            },
            stationConnector: {
                connector_id: 'Id de conector',
                standard: 'Estándar',
                format: 'Formato como tipo',
                power_type: 'Tipo de potencia',
                voltage: 'Voltaxe',
                amperage: 'Amperaxe',
                power_rating: 'Potencia nominal',
            },
            selectTag: 'Seleccionar etiquetas',
            addTagHeader: 'Asociar etiquetas',
            tags: 'Etiquetas',
            yes: 'Si',
            assignedTariff: 'Asignar tarifa',
            assignTariff: 'Asignar tarifa a localizacións',
            delete: 'Eliminar',
            action: 'Acción',
            addPromotion: 'Engadir promoción',
            selectPromotion: 'Seleccionar promoción',
            exportChargeStations: {
                connector_id: 'connector_id',
                max_power: 'max_power',
                cp_id: 'cp_id',
                type: 'tipo',
                location: 'localización',
                station_name: 'station_name',
                address: 'enderezo',
                city: 'cidade',
                postal_code: 'postal_code',
                country: 'país',
                latitude: 'latitude',
                longitude: 'lonxitude',
                evse_id: 'evse_id',
                standard: 'estándar',
                format: 'formato',
                powertype: 'tipo de potencia',
                voltage: 'voltaxe',
                amperage: 'amperaxe',
            },
            gmbLocationID: 'ID de localización de GMB',
            clickHere: 'Faga clic aquí',
            downloadTemplate: 'para descargar o modelo',
            importStationsModel: 'Importar modelo de estacións de carga',
            noDataToExport: 'Non hai datos para exportar.',
            note: 'Nota: ',
            autoCalculateMaxPowerNote:
                'Algúns CPO foron configurados para calcular automaticamente a potencia máxima; ao usar esta importación poderíanse sobrescribir os valores calculados.',
            applyToOrg: 'Aplicable a toda a organización',
        },
        errors: {
            tag: {
                invalid_fromat: 'Caracteres non válidos na etiqueta',
            },
            file: {
                fileType: "Pódense cargar ficheiros con extensión '.csv'.",
            },
            gmbLocationId: {
                valid: 'Introduza un ID de localización de GMB válido',
            },
            common: 'Produciuse un erro. Ténteo de novo',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Gardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            expand: 'Expandir',
            collapse: 'Contraer',
            import: 'Importar',
            synchronize: 'Sincronizar',
            syncStation: 'Sincronizar estación',
            assignTariff: 'Asignar tarifa',
            delete: 'Eliminar',
            add: 'Engadir',
            addSelected: 'Engadir selección',
            addAll: 'Engadir todo',
            yes: 'Si',
            no: 'Non',
            back: 'Volver',
            apply: 'Aplicar',
            editGMBLocationID: 'Editar ID de localización de GMB',
            downloadLocationsData: 'Extraer datos de localizacións de carga',
            exportAll: 'Exportar todo',
            importStationsModel: 'Importar modelo de estacións de carga',
            deleteSelected: 'Eliminar selección',
            export: 'Exportar',
        },
        placeholder: {
            selectStationStatus: 'Seleccionar estado',
            name: 'Nome',
            cp_id: 'CP-Id',
            tags: 'Etiquetas',
            address: 'Enderezo',
            selectTag: 'Seleccionar etiqueta',
            evse_id: 'ID EVSE',
            selectChargePoint: 'Seleccionar CPO',
            selectRegion: 'Seleccionar rexión',
            selectPromotion: 'Seleccionar promoción',
            gmbLocationID: 'ID de localización de GMB',
            selectPowerType: 'Seleccionar tipo de potencia',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            addPromotion: 'Detalles da promoción actualizados correctamente',
            updateAmenitiesSuccess: 'Actualizáronse correctamente os servizos da localización de carga',
            chargePointRequire: 'Requírese polo menos un punto de carga',
            deleteBulkConfirmMessage: 'Seguro que quere eliminar os rexistros seleccionados?',
            applyToAllOrgConfirmMessage:
                'Quere aplicar esta tarifa tamén a organizacións para todas as localizacións? ',
        },
        manageAmenities: 'Xestionar servizos',
    },
    chargeStationMap: {
        title: 'Ver mapa das estacións de carga: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Estacións de carga',
        label: {
            address: 'Enderezo',
            backOfficeUrl: 'URL de Servizos de xestión:',
            amenities: 'Servizos:',
            satellite: 'Satélite',
            map: 'Mapa',
            search: 'Buscar',
            refresh: 'Actualizar',
            apply: 'Aplicar',
            clear: 'Limpar',
            loading: 'Cargando...',
        },
        placeholder: {
            locationSearch: 'Buscar estación',
            mapSearch: 'Busca por nome de rúa, cidade ou código postal',
        },
    },
    promotionsRequest: {
        headerTitle:
            'Solicitude de promocións para condutores: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        title: 'Solicitude de promocións para condutores',
        promotionsRequest: 'Promocións solicitadas',
        columns: {
            driverName: 'Nome do condutor',
            promotionsName: 'Nome das promocións',
            promotionsCode: 'Código',
            approved: 'Estado',
            approvedBy: 'Modificado por',
            approvedDate: 'Data de modificación',
            action: 'Acción',
            email: 'Correo electrónico',
        },
        form: {
            charge: 'Cargando',
            payment: 'Pagamento',
            month: 'Mes',
        },
        label: {
            approved: 'Aprobado',
            pending: 'Pendente',
            rejected: 'Rexeitado',
            modelHeader: 'Promoción solicitada - ',
            enterComment: 'Introduza os seus comentarios',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Volver',
            approved: 'Aprobar',
            pending: 'Pendente',
            rejected: 'Rexeitar',
            action: 'Acción',
            edit: 'Editar',
        },
        placeholder: {
            driverName: 'Nome do condutor',
            promotionsName: 'Nome das promocións',
            promotionsCode: 'Código',
            select: 'Seleccionar estado',
        },
        message: {
            ManagestatusMesage:
                'Faga clic en Aprobada ou Rexeitada para aplicar o estado da solicitude. Unha vez actualizada esta solicitude, xa non poderá editarse.',
        },
    },
    driverAccountBalance: {
        title: 'Saldo da conta do condutor: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        driverAccountBalance: 'Saldo da conta do condutor',
        manageUser: 'Xestionar saldo da conta do condutor',
        placeholder: {
            name: 'Nome / Correo electrónico',
            select: 'Seleccionar estado',
            payment_type: 'Seleccionar tipo de pagamento',
            description: 'Comentario',
            amount: 'Introduza o importe de crédito/débito',
        },
        label: {
            name: 'Nome',
            email: 'Correo electrónico',
            payment_type: 'Tipo de pagamento',
            driver_status: 'Estado da conta',
            current_balance: 'Saldo',
            currency: 'Moeda',
            driver_id: 'Id do condutor',
            action: 'Acción',
            delete: 'Eliminar',
            refundHeader: 'Retirada de fondos',
            creditPayment: 'Conta de crédito',
            prePayment: 'Conta de prepagamento',
            enabled: 'Activado',
            disabled: 'Desactivado',
            refund: 'Modificar saldo da conta',
            description: 'Comentario',
            amount: 'Introduza o importe de crédito/débito',
            additional_payment: 'Pagamento adicional',
            payment_refunds: 'Retiradas de pagamentos',
            payment_settlement: 'Modificación do saldo - Solicitude',
            balance: 'Tipo de saldo',
            accountBalance: 'Fondos da conta',
            referralBonus: 'Bonificación por recomendación',
            rewardBalance: 'Saldo de recompensas',
            total_balance: 'Saldo total',
            rewards: 'Recompensas',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            add: 'Engadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            send_for_approval: 'Enviar para aprobación',
        },
        message: {
            deleteConfirmMesage:
                'A etiqueta eliminarase de todos os condutores asociados e da localización de carga. Seguro que quere eliminar?',
        },
        errors: {
            name: 'Caracteres non válidos na etiqueta',
            amount: {
                moreThan: 'O importe debe ser maior/menor que 0',
                maxcredit: 'Acadouse o límite máximo para o crédito da conta',
                maxdebit: 'Acadouse o límite máximo para o débito en conta',
            },
        },
    },
    driverPromotions: {
        title: 'Xestionar promoción: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        manageDriverPromotion: 'Xestionar promoción',
        driverPromotions: 'Promocións',
        label: {
            name: 'Nome',
            code: 'Código',
            errorMessage: 'Mensaxe de erro',
            used: 'Usado',
            unUsed: 'Sen uso',
            uploadFileErrorMessage: 'Erros ao cargar códigos promocionais.',
            updatePromotionCode: 'Actualizar código promocional',
            unique_code: 'Código único',
            uniquePromotionCode: 'Códigos promocionais',
            importDriverPromotionCodeHeader: 'Importar código promocional para condutores',
            csvFile: 'Códigos promocionais',
            promotionCode: 'Código promocional',
            usedBy: 'Usado por',
            description: 'Descrición',
            tarrif: 'Tarifa',
            accountCredit: 'Crédito da conta',
            discountRatePeriod: 'Período da taxa de desconto',
            indays: '(Días)',
            intilakWhRate: 'Taxa kWh inicial',
            ivRewardsPromotion: 'IV promoción de recompensas',
            referralPromotion: 'Promoción de recomendación',
            expiryDate: 'Data de caducidade',
            needApprovalToJoinPromotion: 'Necesita aprobación para unirse á promoción',
            newDriversOnly: 'Só novos condutores',
            forOrganisation: 'Para Organización',
            createdDate: 'Data de creación',
            action: 'Acción',
            status: 'Estado',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            enabled: 'Activado',
            disabled: 'Desactivado',
            deleted: ' (Eliminado)',
            csvFileSupported: 'Só se admiten ficheiros CSV',
            clickHere: 'Faga clic aquí',
            downloadTemplate: 'para descargar o modelo',
            exportColumnHeder: 'promotion_codes',
            min_kwh_package_promotion: 'KWh mínimo',
            package_promotion_period: 'Período de promoción do paquete (días)',
            package_promotion_volt_bonus: 'Número de voltios recibidos como recompensa',
            rfidCardUnitPrice: 'Prezo unitario da tarxeta RFID',
            subscription: 'Subscrición Premium',
            tariffUpdate: 'Actualización de tarifas',
            currentTariff: 'Tarifa actual',
            next: 'Seguinte',
            newTariff: 'Nova tarifa',
            save: 'Gardar',
        },
        placeholder: {
            name: 'Nome',
            promotionCode: 'Código promocional',
            selectTariff: 'Seleccionar tarifa',
            selectStatus: 'Seleccionar estado',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            forOrganisation: 'Para Organización',
            min_kwh_package_promotion: 'KWh mínimo',
            package_promotion_period: 'Período de promoción do paquete',
            package_promotion_volt_bonus: 'Número de voltios recibidos como recompensa',
            rfidCardUnitPrice: 'Prezo unitario da tarxeta RFID',
            premium_subscription: 'Subscrición Premium',
            selectCurrentTariff: 'Seleccionar a tarifa actual',
            selectNewTariff: 'Seleccionar nova tarifa',
        },
        button: {
            update: 'Actualizar',
            import: 'Importar',
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            add: 'Engadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            subscriptionChangeWarningMessage:
                'Aviso: Ao cambiar o tipo de subscrición, cancelaranse todas as renovacións automáticas da conta de condutor asociada.',
            tariffUpdateNote: 'A nova tarifa asignarase ás seguintes promocións:',
            updateTariffConfirmMessage: 'Seguro que quere actualizar a tarifa para as promocións seleccionadas?',
            selectOneRecord: 'Seleccione polo menos unha promoción na que actualizar a tarifa',
        },
        errors: {
            promotionName: {
                valid: 'Introduza un nome de promoción válido',
            },
            promotionCode: {
                valid: 'Introduza un código promocional válido',
            },
            accountCredit: {
                moreThan: 'O crédito da conta debe ser superior a 0',
                max: 'Acadouse o límite máximo para o crédito da conta',
                typeError: 'Introduza un importe de crédito da conta válido',
            },
            discountRatePeriod: {
                moreThan: 'O período da taxa de desconto debe ser superior a 0',
            },
            intialRate: {
                max: 'A taxa non pode ser superior a 100',
                min: 'A taxa non pode ser inferior a 0',
                typeError: 'Introduza unha tarifa válida',
            },
            common: 'Produciuse un erro, ténteo de novo.',
            file: {
                fileType: "Pódense cargar ficheiros con extensión '.csv'.",
            },
            maxValue: 'O valor máximo non debe ser superior a 2147483647',
            rfidCardUnitPrice: {
                max: 'O prezo unitario da tarxeta RFID non pode ser superior a 1000',
            },
        },
    },
    paymentApproval: {
        headerTitle:
            'Aprobacións de saldo de conta - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        title: 'Aprobacións de saldos de conta',
        transaction: 'Transacción',
        columns: {
            email: 'Correo electrónico',
            amount: 'Importe',
            status: 'Estado',
            request_by: 'Solicitado por',
            request_date: 'Solicitado o',
            request_by_comment: 'Solicitado por Comentarios',
            review_by: 'Revisado por',
            review_date: 'Revisado o',
            review_comment: 'Comentarios do revisor',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Pechando',
            transaction: 'ID de transacción',
            name: 'Nome',
            action: 'Acción',
            request_type: 'Tipo de solicitude',
            invoice: 'Factura',
        },
        form: {
            driver: 'Condutor',
            organisation: 'Organización',
            month: 'Mes',
        },
        label: {
            request_type: 'Tipo de solicitude',
            refundHeader: 'Modificación do saldo',
            pending: 'Pendente',
            approved: 'Aprobar',
            declined: 'Rexeitar',
            approve: 'Aprobar',
            decline: 'Rexeitar',
            comment: 'Introduza os seus comentarios',
            status: 'Estado',
            refund: 'Aprobar crédito/débito',
            refundAmount: 'Importe de retirada de fondos ',
            commentsFrom: 'Comentarios de',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
        },
        placeholder: {
            comment: 'Introduza os seus comentarios',
            status: 'Seleccionar estado',
            name: 'Nome / Correo electrónico',
            refundAmount: 'Importe de retirada de fondos ',
        },
        message: {
            noDataToExport: 'Non hai datos para exportar.',
            selectApprovalOrReject: 'Aprobe ou rexeite esta solicitude.',
        },
    },
    paymentScheduleSetting: {
        title: 'Calendario de pagamentos: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Calendario de pagamentos',
        note: ' Programe un traballo en segundo plano para liquidar as facturas pendentes pola recarga do VE realizada polos condutores.',
        placeholder: {
            day_of_week: 'Día da semana',
        },
        label: {
            daily: 'Diario',
            weekly: 'Semanal',
            day_of_week: 'Día da semana',
            selectDay: 'Seleccionar día',
        },
        day_of_week: {
            monday: 'MARTES',
            tuesday: 'MÉRCORES',
            wednesday: 'XOVES',
            thursday: 'VENRES',
            friday: 'SÁBADO',
            saturday: 'DOMINGO',
            sunday: 'LUNS',
        },
        button: {
            save: 'Gardar',
        },
    },
    paymentFailures: {
        title: 'Erros de pagamento: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        managePaymentFailures: 'Erros de pagamento',
        placeholder: {
            name: 'Nome / Correo electrónico',
            note: 'Observación',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            select: 'Seleccionar estado',
            status: 'Seleccionar estado',
            failureReason: 'Motivo do erro',
        },
        label: {
            name: 'Nome',
            email: 'Correo electrónico',
            transaction_id: 'ID de transacción',
            total_amount: 'Importe total',
            currency_name: 'Moeda',
            created_date: 'Data de creación',
            status: 'Estado',
            note: 'Observación',
            action: 'Acción',
            editHeader: 'Actualizar o estado do pagamento',
            pending: 'Pendente',
            acknowledged: 'Confirmado',
            closed: 'Pechado',
            transactionDetails: 'Detalles da transacción',
            transaction_request: 'Solicitude de transacción',
            transaction_response: 'Resposta á transacción',
            error_message: 'Mensaxe de erro',
            error_code: 'Código de erro',
            request_type: 'Tipo de solicitude',
            response_code: 'Código de resposta',
            response_code_description: 'Descrición do código de resposta',
            null_data: 'Non se atoparon datos',
            transaction_date: 'Data da transacción',
            failureReason: 'Motivo do erro',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            add: 'Engadir',
            edit: 'Editar estado',
            reset: 'Restablecer',
            yes: 'Si',
            no: 'Non',
            action: 'Acción',
            back: 'Volver',
        },
    },
    chargeTariff: {
        title: 'Tarifas: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Tarifas',
        tariff: 'Tarifa',
        label: {
            name: 'Nome',
            vat_name: 'Nome do IVE',
            vat_rate: 'Taxa (%)',
            vat_description: 'Descrición',
            cpo_id: 'Id do cpo',
            action: 'Acción',
            url: 'URL',
            currency: 'Moeda',
            createdDate: 'Data de creación',
            status: 'Estado',
            enabled: 'Activado',
            deleted: 'Eliminado',
            detail: 'Detalle',
            promotions: 'Promocións',
            lastUpdated: 'Última actualización',
            promotionCode: 'Código promocional',
            description: 'Descrición',
            expiryDate: 'Data de caducidade',
            priceComponents: 'Compoñentes do prezo',
            priceComponent: 'Compoñente do prezo',
            type: 'TIPO',
            price: 'PREZO',
            pricePerHour: 'Prezo (por hora)',
            restriction: 'Restrición',
            startDate: 'Data de inicio',
            startTime: 'Hora de inicio',
            endDate: 'Data de fin',
            endTime: 'Hora de fin',
            minkWh: 'KWh mínimo',
            maxkWh: 'KWh máximo',
            minPower: 'Potencia Mínima',
            maxPower: 'Potencia Máxima',
            minDuration: 'Duración Mín',
            maxDuration: 'Duración Máx',
            weekDays: 'Días da semana',
            selectVat: 'Seleccionar IVE',
            attachVat: 'Anexar IVE',
            vatdetail: 'Detalle do IVE',
            editVAT: 'Editar tipo de IVE',
            vatType: 'Tipo de IVE',
            tariffID: 'ID da tarifa',
            element: 'ELEMENTO',
            prices: 'Prezos',
            restrictions: 'Restricións',
            stepSize: 'GRANULARIDADE',
            vat: 'IVE',
            date: 'DATA',
            time: 'HORA',
            kwh: 'KWH',
            power: 'POTENCIA (KW)',
            duration: 'DURACIÓN (SEC)',
            current: 'CORRENTE (AMP)',
            maxCurrent: 'Corrente Máxima',
            minCurrent: 'Corrente Mínima',
            restrictionTitle: 'RESTRICIÓN',
            details: 'Detalles',
            weekDaysTitle: 'DÍAS DA SEMANA',
            maxKwhTitle: 'KWH Máximo',
            minKwhTitle: 'KWH Mínimo',
        },
        placeholder: {
            name: 'Nome',
            selectStatus: 'Seleccionar estado',
            selectVat: 'Seleccionar IVE',
            selectType: 'Seleccionar tipo de IVE',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            edit: 'Editar',
            detail: 'Detalle',
            add: 'Engadir',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            editvat: 'Anexar IVE',
            editVAT: 'Editar tipo de IVE',
            groupRestrictions: 'Restricións de Tarifa de Grupo',
            ungroupRestrictions: 'Restricións de Tarifa Sen Agrupar',
        },
        noRestrictionAvailable: 'Non Hai Restricións Dispoñibles',
    },
    partnerPromotion: {
        title: 'Promocións de socios: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Promocións para socios',
        placeholder: {
            nameorcompany: 'Nome ou empresa',
            status: 'Seleccionar estado',
            date_from: 'Data de inicio',
            date_to: 'Data de fin',
        },
        label: {
            name: 'Nome',
            company: 'Empresa',
            description: 'Descrición',
            date_from: 'Data de inicio',
            date_to: 'Data de fin',
            expiry_date: 'Data de caducidade',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activado',
            disabled: 'Desactivado',
            delete: 'Eliminar',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Engadir',
            save: 'Gardar',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            enable: 'Activar',
            disable: 'Desactivar',
            chargeStation: 'Estacións de carga',
            preview: 'Vista previa',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
        },
        insert: {
            header: 'Xestionar as promocións de socios',
            placeholder: {
                name: 'Nome',
                company: 'Información sobre a empresa',
                description: 'Descrición',
                start_date: 'Data de inicio',
                expiry_date: 'Data de caducidade',
                offer_duration: '60 minutos',
                stored_for_future_use_days: '2 días',
                qr_code_details: 'Información sobre o código QR',
                certificate: 'Certificado',
                image: 'Imaxe da oferta',
                image1: 'Imaxe adicional 1',
                image2: 'Imaxe adicional 2',
                image3: 'Imaxe adicional 3',
                image4: 'Imaxe adicional 4',
                image5: 'Imaxe adicional 5',
                banner_image: 'Logotipo da promoción',
                locationPageImage: 'Imaxe da páxina de localización',
                displayOnChargeLocation: 'Mostrar na pantalla de localización de carga',
                promotion_button_text: 'Texto do botón de promoción',
            },
            label: {
                name: 'Nome',
                company: 'Empresa',
                description: 'Descrición',
                start_date: 'Data de inicio',
                expiry_date: 'Data de caducidade',
                offer_duration: 'Duración da oferta (minutos)',
                stored_for_future_use_days: 'Gardar para uso futuro (días)',
                always_display_on_partner_promotion: 'Mostrar sempre a promoción de socios',
                qr_code_details: 'Código QR',
                certificate: 'Certificado',
                image: 'Imaxe da oferta',
                banner_image: 'Logotipo da promoción (1030 X 430)',
                layout: 'Deseño de pantalla',
                note1: 'Teña en conta que, Compre mencionar <strong>##image##</strong> e <strong>##qrcode##</strong> sobre o deseño de pantalla HTML para substituír os datos correspondentes. Pódense engadir imaxes adicionais a un deseño usando o código ##image0X##, onde X pode abranguer de 1 a 5.',
                qr_code_note:
                    'Teña en conta que debe indicar <strong>##ChargeTransID##</strong>, <strong>##StartChargeTS##</strong>, <strong>##ChargeStationID##</strong> e <strong>##ChargeStationAddress##</strong> no código QR para substituír os datos correspondentes.',
                locationPageImage: 'Imaxe da páxina de localización',
                displayOnChargeLocation: 'Mostrar na pantalla de localización de carga',
                partner_promotion_display_type: 'Tipo de pantalla da promoción',
                promotion_button_text: 'Texto do botón de promoción',
                open_external_url: 'Abrir URL externo',
                external_url: 'URL externo',
                image1: 'Imaxe adicional 1',
                image2: 'Imaxe adicional 2',
                image3: 'Imaxe adicional 3',
                image4: 'Imaxe adicional 4',
                image5: 'Imaxe adicional 5',
            },
            errors: {
                common: 'Produciuse un erro, ténteo de novo.',
                name: {
                    valid: 'Introduza un nome de promoción válido',
                    max: 'O nome da promoción é demasiado grande',
                },
                description: {
                    max: 'A descrición da promoción é demasiado grande',
                },
                offer_duration: {
                    moreThan: 'A duración da oferta debe ser superior a 0',
                    max: 'A duración da oferta non pode ser superior a 60 minutos',
                },
                stored_for_future_use_days: {
                    moreThan: 'Os días almacenados para uso futuro deben ser superiores a 0',
                    max: 'Os días almacenados para uso futuro non poden ser superiores a 99 días',
                },
                banner_image: {
                    dimensions: 'O logotipo da promoción debe ter unhas dimensións de 1030 X 430',
                },
                image: {
                    fileType: "Pódense cargar ficheiros con extensión '.jpg', '.png', '.svg', '.jpeg'",
                    location_page_image: 'Imaxe da páxina de localización é un campo obrigatorio',
                },
                certificate: {
                    fileType: "Pódense cargar ficheiros con extensión '.crt', '.cer'",
                },
                promotion_button_text: {
                    valid: 'Introduza o texto válido do botón de promoción',
                },
                external_url: {
                    url: 'O URL externo debe ser un URL válido',
                },
            },
        },
        assign: {
            header: 'Estacións de carga',
            headerModal: 'Estación de carga',
            placeholder: {
                name: 'Introduza o nome',
                locationName: 'Introduza o nome da localización',
                address: 'Enderezo',
                tags: 'Seleccionar etiquetas',
            },
            label: {
                add: 'Engadir',
                name: 'Nome',
                type: 'Tipo',
                address: 'Enderezo',
                city: 'Cidade',
                postcode: 'Código postal',
                last_updated: 'Data de modificación',
                action: 'Acción',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Seguro que quere eliminar?',
            },
        },
    },
    CPOInterface: {
        title: 'Contas: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Contas',
        placeholder: {
            name: 'Nome',
            status: 'Seleccionar estado',
        },
        label: {
            name: 'Nome',
            party_id: 'ID de terceiros',
            country_code: 'Código do país',
            version_url: 'URL de versión',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activado',
            disabled: 'Desactivado',
            locationGroup: 'Localización do grupo',
            yes: 'Si',
            no: 'Non',
            rfidDriverTokens: 'Compartir só tokens de condutor RFID',
            vat_type: 'Tipo de IVE',
            version_2_1_1: '2.1.1',
            version_2_2: '2.2',
            version_2_2_1: '2.2.1',
            external_cpo: 'CPO internacional de ##COMPANY_BRAND_NAME##',
            cpo_type: 'Tipo CPO',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Engadir',
            save: 'Gardar',
            edit: 'Editar',
            reset: 'Restablecer',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            enable: 'Activar',
            disable: 'Desactivar',
            getCredentials: 'Obter credenciais',
            performHandshake: 'Realizar apretón de mans',
            reHandshake: 'Volver realizar apretón de mans',
            generateHandshakeToken: 'Xerar token de apretón de mans',
            reGenerateHandshakeToken: 'Rexenerar token de apretón de mans',
            changeMutualOCPIVersion: 'Cambiar versión mutua OCPI',
            handshakeDetails: 'Detalles do apretón de mans',
        },
        message: {
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage:
                'Desactivar este CPO deterá toda a comunicación OCPI, ocultará as localizacións de carga asociadas nas aplicacións, marcará as estacións de carga vinculadas como "Eliminadas" e eliminará as localizacións dos grupos de acceso. Estás seguro de que queres continuar?',
        },
        insert: {
            header: 'Xestionar operador de punto de carga',
            placeholder: {
                name: 'Nome',
                party_id: 'ID de terceiros',
                country_code: 'Código do país',
                ocpi: 'EMSP',
                version_url: 'URL de versión do CPO',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                colour_code: 'Código de cores',
                back_office_url: 'URL de Servizos de xestión',
                vat_type: 'Tipo de IVE',
                region: 'Seleccionar rexión',
                vat: 'Seleccionar IVE',
                cpo_type: 'Tipo CPO',
            },
            label: {
                name: 'Nome',
                party_id: 'ID de terceiros',
                country_code: 'Código do país',
                ocpi: 'EMSP',
                version_url: 'URL de versión',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                locationGroup: 'Localización do grupo',
                rfidDriverTokens: 'Compartir só tokens de condutor RFID',
                colour_code: 'Código de cores',
                back_office_url: 'URL de Servizos de xestión',
                vat_type: 'Tipo de IVE',
                disableLocationPatchPutRemovals: 'Desactivar as eliminacións PATCH/PUT da localización',
                enableAutoMaxPowerCalculation: 'Activar o cálculo automático da potencia máxima',
                mutual_ocpi_version: 'Versión de OCPI mutua',
                externalCPO: 'Rexión asociada',
                is_external: 'CPO internacional de ##COMPANY_BRAND_NAME##',
                defaultVat: 'IVE predefinido (anular)',
                gmbAccountID: 'ID de conta de GMB',
                cpo_type: 'Tipo CPO',
            },
            errors: {
                common: 'Produciuse un erro, ténteo de novo.',
                name: {
                    valid: 'Introduza un nome de CPO válido',
                },
                party_id: {
                    valid: 'Introduza un ID de terceiros válido',
                },
                country_code: {
                    valid: 'Introduza un código de país válido',
                },
                version_url: {
                    url: 'O URL da versión debe ser un URL válido',
                },
                colour_code: {
                    valid: 'Introduza un código de cor válido',
                },
                back_office_url: {
                    url: 'O URL de Servizos de xestión debe ser un URL válido',
                },
            },
        },
        versionEndpoints: {
            header: 'Extremos da versión',
            label: {
                version: 'Versión',
                identifier: 'Identificador',
                role: 'Función',
                url: 'URL',
                last_executed: 'Data da última sincronización',
            },
        },
        modal: {
            message:
                'Está a marcar este CPO como CPO internacional de ##COMPANY_BRAND_NAME##, precisa engadir esta localización de CPO manualmente no grupo de acceso público',
            okButton: 'Aceptar',
        },
        performHandshakeModal: {
            handshakeHeader: 'Realizar apretón de mans',
            reHandshakeHeader: 'Volver realizar apretón de mans',
            label: {
                mutual_ocpi_version: 'Versión mutua OCPI',
                version_url: 'URL da versión',
                handshake_token: 'Token de apretón de mans',
            },
            placeholder: {
                mutual_ocpi_version: 'Versión mutua OCPI',
                version_url: 'URL da versión',
                handshake_token: 'Token de apretón de mans',
            },
            button: {
                cancel: 'Cancelar',
                generateHandshakeToken: 'Xerar token de apretón de mans',
                confirm: 'Confirmar',
                connect: 'Conectar',
                reconnect: 'Reconectar',
            },
            confirmationModal: {
                header: 'Realizar apretón de mans',
                rehandshakeMessage:
                    'As credenciais CPO cambiaranse despois de volver realizar o apretón de mans. Está seguro de que desexa continuar co novo apretón de mans?',
                tokenGeneratedMessage:
                    'O token de apretón de mans para o CPO xa xerouse. Se o token se lle dá ao CPO e o CPO intenta realizar un apretón de mans co EMSP, pode fallar. Está seguro de que desexa continuar co novo apretón de mans?',
            },
            cpoAuthTokenMessage: 'O valor predeterminado que se mostra aquí é o token de autenticación CPO',
        },
        generateHandshakeTokenModal: {
            header: 'Xerar token de apretón de mans',
            reGenerateTokenHeader: 'Volver xerar token de apretón de mans',
            label: {
                handshakeToken: 'Token de apretón de mans',
                emsp_auth_token: 'Token de autenticación EMSP',
                emspVersionURL: 'URL da versión EMSP',
            },
            Placeholder: {
                handshakeToken: 'Token de apretón de mans',
                emsp_auth_token: 'Token de autenticación EMSP',
            },
            button: {
                save: 'Gardar',
                copyToClipboard: 'Copiar no portapapeis',
                generateToken: 'Xerar',
                reGenerateToken: 'Volver xerar',
                confirm: 'Confirmar',
                cancel: 'Cancelar',
            },
            copyToClipboard: {
                success: 'Token copiado no portapapeis',
                failed: 'Erro ao copiar o token',
            },
            confirmationModal: {
                confirmationMessage:
                    'Se se lle dá o token de apretón de mans antigo ao CPO, pode fallar se o CPO intenta usalo para o apretón de mans. Está seguro de que desexa gardar o novo token de apretón de mans?',
                header: 'Gardar token',
            },
            emspAuthTokenMessage: 'O valor predeterminado que se mostra aquí é o token de autenticación EMSP',
        },
        changeMutualOCPIVersionModal: {
            header: 'Cambiar versión mutua OCPI',
            label: {
                mutualOCPIVersion: 'Versión mutua OCPI',
            },
            button: {
                save: 'Gardar',
                cancel: 'Cancelar',
                confirm: 'Confirmar',
            },
            confirmationModal: {
                confirmationMessage: 'Está seguro de que desexa actualizar a versión mutua OCPI?',
            },
        },
        handshakeDetailsModal: {
            header: 'Detalles do apretón de mans',
            label: {
                version_url: 'URL da versión',
                handshakeToken: 'Token de apretón de mans',
                emspAuthToken: 'Token de autenticación EMSP',
                cpoAuthToken: 'Token de autenticación CPO',
            },
        },
    },
    CPOInternalTransfers: {
        title: 'Transferencias internas: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Transferencias internas',
        transferDetailTitle:
            'Detalles da transferencia: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        transferDetailHeader: 'Detalles da transferencia',
        label: {
            transfer_id: 'ID da transferencia',
            gross_value: 'Valor bruto',
            created_date: 'Data de creación',
            action: 'Acción',
            transferNumber: 'Número da transferencia',
            transferDate: 'Data da transferencia',
            transaction: 'ID de transacción',
            transactionStartDate: 'Data de inicio da transacción',
            transactionEndDate: 'Data de fin da transacción',
            publicCardId: 'ID de tarxeta pública',
            driverAccountId: 'ID da conta do condutor',
            driverName: 'N.º de condutor/vehículo',
            stationId: 'ID de estación',
            stationName: 'Nome da estación',
            stationAddress: 'Enderezo da estación',
            kwh: 'kWh',
            price_per_kwh: 'Prezo/kWh',
            disable: 'DESACTIVADO',
        },
        placeholder: {
            start_date: 'Data de inicio',
            end_date: 'Data de fin',
            status: 'Estado',
            cpo: 'Seleccionar CPO',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
        },
        errors: {
            cpo: {
                required: 'Seleccione CPO',
            },
        },
    },
    PSPSetting: {
        title: 'Fornecedores de servizos de pagamento: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Fornecedores de servizos de pagamento',
        placeholder: {
            name: 'Nome',
            status: 'Seleccionar estado',
            type: 'Seleccionar tipo',
        },
        label: {
            name: 'Nome',
            code: 'Código',
            type: 'Tipo',
            description: 'Descrición',
            store_name: 'Tenda',
            department_name: 'Departamento',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activado',
            disabled: 'Desactivado',
            details: 'Detalles',
            key: 'Chave',
            value: 'Valor',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Engadir',
            save: 'Gardar',
            edit: 'Editar',
            reset: 'Restablecer',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            enable: 'Activar',
            disable: 'Desactivar',
            getCredentials: 'Obter credenciais',
            delete: 'Eliminar',
        },
        message: {
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
        },
        insert: {
            header: 'Xestionar o fornecedor de servizos de pagamento',
            placeholder: {
                name: 'Nome',
                type: 'Tipo',
                description: 'Descrición',
                store_name: 'Nome da tenda',
                store_id: 'ID da tenda',
                merchant_name: 'Nome do vendedor',
                merchant_id: 'ID do vendedor',
                department_name: 'Nome do departamento',
                department_id: 'ID do departamento',
                signature_key: 'Clave de sinatura',
                secret_key: 'Clave secreta',
                user_name: 'Nome de usuario',
                password: 'Contrasinal',
                data: 'Datos',
                category: 'Categoría',
                url: 'URL',
                acquirerId: 'ID de comprador',
                firstName: 'Nome',
                lastName: 'Apelidos',
                houseName: 'Nome da casa',
                postcode: 'Código postal',
                donationProviderType: 'Tipo de fornecedor de doazón',
                isGiftAid: 'É Gift Aid',
                donationStoreId: 'ID da tenda de doazón',
                donationMerchantNumber: 'Número do vendedor da doazón',
                clientID: 'ID de cliente',
                clientSecret: 'Segredo de cliente',
                terminalID: 'ID de terminal',
                enableCardRefunds: 'Activar as devolucións na tarxeta',
                enableCardVerification: 'Activar a verificación de tarxeta',
                enableCharity: 'Activar organización benéfica',
            },
            label: {
                name: 'Nome',
                type: 'Tipo',
                firstName: 'Nome',
                lastName: 'Apelidos',
                houseName: 'Nome da casa',
                postcode: 'Código postal',
                donationProviderType: 'Tipo de fornecedor de doazón',
                isGiftAid: 'É Gift Aid',
                donationStoreId: 'ID da tenda de doazón',
                donationMerchantNumber: 'Número do vendedor da doazón',
                code: 'Código',
                description: 'Descrición',
                store_name: 'Nome da tenda',
                store_id: 'ID da tenda',
                merchant_name: 'Nome do vendedor',
                merchant_id: 'ID do vendedor',
                department_name: 'Nome do departamento',
                department_id: 'ID do departamento',
                signature_key: 'Clave de sinatura',
                secret_key: 'Clave secreta',
                user_name: 'Nome de usuario',
                password: 'Contrasinal',
                data: 'Datos',
                action_urls: 'URL de acción',
                category: 'Categoría',
                url: 'URL',
                acquirerId: 'ID de comprador',
                clientID: 'ID de cliente',
                clientSecret: 'Segredo de cliente',
                terminalID: 'ID de terminal',
                enableCardRefunds: 'Activar as devolucións na tarxeta',
                enableCardVerification: 'Activar a verificación de tarxeta',
                enableCharity: 'Activar organización benéfica',
                mobileMerchantId: 'ID de vendedor móbil',
                mobileMerchantPassword: 'Contrasinal de vendedor móbil',
            },
            errors: {
                common: 'Produciuse un erro, ténteo de novo.',
                name: {
                    valid: 'Introduza un nome válido',
                },
                code: {
                    valid: 'Introduza un código válido',
                },
                url: {
                    valid: 'O URL debe ser un URL válido',
                },
                DatatransSupportCards: {
                    valid: 'Introduce un valor válido para DatatransSupportCards',
                },
            },
        },
    },
    RFIDCards: {
        title: 'Tarxetas RFID: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Tarxetas RFID',
        placeholder: {
            name: 'Nome / Correo electrónico / Organización do condutor',
            manufacturer: 'Fabricante',
            part_id: 'ID de terceiros',
            public_card_id: 'ID de tarxeta pública',
            status: 'Seleccionar estado',
            mifare_uid: 'UID de Mifare',
        },
        label: {
            name: 'Asignada a',
            email_vehicle: 'Conta asociada',
            manufacturer: 'Fabricante',
            part_id: 'ID de terceiros',
            public_card_id: 'ID de tarxeta pública',
            private_card_id: 'ID de tarxeta privada',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activado',
            disabled: 'Desactivado',
            delete: 'Eliminar',
            deAllocate: 'Eliminar asociación',
            view: 'Ver detalle',
            allocateCardToOrganisation: 'Asignar tarxetas en masa á organización',
            mifare_uid: 'UID DE MIFARE',
            reinstate: 'Restaurar tarxeta',
            card_type: 'Tipo de tarxeta',
            removeBulkAssociation: 'Eliminar a asociación de tarxetas RFID en masa',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Engadir',
            addBulk: 'Engadir tarxetas en masa á fabricación',
            assing: 'Asignar tarxetas RFID',
            allocateRFIDCard: 'Repartir tarxeta RFID',
            import: 'Importar ficheiro de fabricación',
            export: 'Exportar ficheiro de fabricación',
            save: 'Gardar',
            edit: 'Editar',
            reset: 'Restablecer',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            enable: 'Activar',
            disable: 'Desactivar',
            getCredentials: 'Obter credenciais',
            delete: 'Eliminar',
            deAllocate: 'Eliminar asociación',
            view: 'Ver detalle',
            reinstate: 'Restaurar tarxeta',
            forceCPOUpdate: 'Forzar actualización de CPO',
        },
        errors: {
            export: {
                notSeletedCards: 'Seleccione tarxetas de exportación en espera',
            },
        },
        message: {
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            deAllocateConfirmMesage: 'Seguro que quere eliminar a asociación da tarxeta RFID a unha conta?',
            reinstateConfirmMessage: 'Seguro que quere restaurar a tarxeta RFID?',
            forceCPOUpdateConfirmMessage: 'Seguro que quere forzar o token de actualización no sistema do CPO?',
        },
        insert: {
            header: 'Xestionar tarxetas RFID',
            placeholder: {
                manufacturer: 'Nome do fabricante',
                part_id: 'ID de terceiros',
                public_card_id: 'ID de tarxeta pública',
                private_card_id: 'ID de tarxeta privada',
                mifare_uid: 'UID de Mifare',
                card_type: 'Tipo de tarxeta',
            },
            label: {
                manufacturer: 'Fabricante',
                part_id: 'ID de terceiros',
                public_card_id: 'ID de tarxeta pública',
                private_card_id: 'ID de tarxeta privada',
                mifare_uid: 'UID de Mifare',
                card_type: 'Tipo de tarxeta',
            },
            errors: {
                common: 'Produciuse un erro, ténteo de novo.',
                name: {
                    valid: 'Introduza un nome válido',
                },
                code: {
                    valid: 'Introduza un código válido',
                },
                url: {
                    valid: 'O URL debe ser un URL válido',
                },
            },
        },
        bulkCards: {
            header: 'Engadir tarxetas masivas',
            placeholder: {
                manufacturer: 'Nome do fabricante',
                part_id: 'ID de terceiros',
                no_of_cards: '100 tarxetas',
                cardType: 'Seleccionar tipo de tarxeta',
            },
            label: {
                manufacturer: 'Nome do fabricante',
                part_id: 'ID de terceiros',
                no_of_cards: 'Nº de tarxetas',
                cardType: 'Tipo de tarxeta',
            },
            button: {
                yes: 'Crear tarxetas',
                no: 'Cancelar',
            },
            errors: {
                no_of_cards: {
                    min: 'O n.º de tarxetas non pode ser inferior a 1',
                },
            },
        },
        assignCards: {
            header: 'Asignar tarxetas RFID',
            header2: 'Seleccionou X tarxetas.',
            selectedCard: 'Seleccionou 1 tarxeta.',
            placeholder: {
                manufacturer: 'Nome do fabricante',
                part_id: 'ID de terceiros',
                no_of_cards: '100 tarxetas',
            },
            label: {
                driver: 'Condutor',
                organisation: 'Organización',
                no_of_cards: 'Nº de tarxetas',
            },
            button: {
                yes: 'Asignar',
                no: 'Cancelar',
            },
            form: {
                type: {
                    driver: 'Condutor',
                    organisation: 'Organización',
                },
                driver: 'Condutor',
                organisation: 'Organización',
                placeholder: {
                    driver: 'Seleccionar condutor',
                    organisation: 'Seleccionar organización',
                },
            },
            errors: {
                notSeletedCards: 'Seleccione as tarxetas dispoñibles',
            },
        },
        disableCards: {
            header: 'Desactivar',
            header2: 'Seguro que quere desactivar?',
            placeholder: {
                comment: 'Escriba un comentario',
            },
            label: {
                comment: 'Comentario',
            },
            button: {
                yes: 'Si',
                no: 'Non',
            },
        },
        allocateCards: {
            header: 'Asignar tarxetas RFID',
            placeholder: {
                file: 'Seleccionar ficheiro CSV',
                selectOrganisation: 'Seleccionar organización',
            },
            label: {
                file: 'Ficheiro CSV',
                organisation: 'Organización',
                mifareUID: 'UID de Mifare',
                publicCardID: 'ID de tarxeta pública',
                clickHere: 'Faga clic aquí',
                downloadTemplate: 'para descargar o modelo',
            },
            button: {
                allocate: 'Asignar',
                cancel: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: "Pódense cargar ficheiros con extensión '.csv'.",
                },
            },
        },
        removeAssociation: {
            header: 'Eliminar a asociación de tarxetas RFID en masa',
            placeholder: {
                file: 'Seleccionar ficheiro CSV',
            },
            label: {
                file: 'Ficheiro CSV',
                clickHere: 'Faga clic aquí',
                downloadTemplate: 'para descargar o modelo',
            },
            button: {
                save: 'Gardar',
                cancel: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: "Pódense cargar ficheiros con extensión '.csv'.",
                },
                maxRFIDRecordsReached:
                    'O ficheiro CSV que cargou acadou o número máximo de 10.000 rexistros de ID de tarxeta pública de RFID. Reduza os rexistros de ID de tarxeta pública de RFID no ficheiro csv.',
            },
        },
        importCards: {
            header: 'Importar tarxetas RFID',
            placeholder: {
                file: 'Seleccionar ficheiro CSV',
            },
            label: {
                file: 'Ficheiro CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancelar',
            },
            errors: {
                file: {
                    fileType: "Pódense cargar ficheiros con extensión '.csv'.",
                },
            },
        },
        importCardsDetails: {
            header: 'Detalles da importación de tarxetas RFID',
            label: {
                unSuccessfullImport: 'Non se poden importar as seguintes tarxetas',
                successfullImport: 'As seguintes tarxetas importáronse correctamente',
                failerReason: 'Razón do fallo',
                publicCardId: 'ID de tarxeta pública',
            },
            message: {
                defualtErrorMessage: 'Hai un problema ao importar as seguintes tarxetas.',
            },
        },
        rfidDetails: {
            label: {
                event_date: 'Data do evento',
                chargeLocation: 'Localización de carga',
                charge_station_name: 'Nome da estación',
                response_status: 'Estado da resposta',
            },
        },
    },

    referralPromotion: {
        title: 'Promoción de recomendación: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Promocións por recomendacións',
        manageReferralPromotion: 'Xestionar promoción de recomendación',
        label: {
            name: 'Nome',
            code: 'Código',
            minCharge: 'Mín. Carga',
            maxLimit: 'Máx. Límite',
            maxRefreeLimit: 'Máx. Límite de recomendados',
            createdDate: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            disabled: 'Desactivado',
            enabled: 'Activado',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            promotionCode: 'Código promocional',
            description: 'Descrición',
            maxReferralLimit: 'Límite máximo de recomendacións',
            minChargeValue: 'Valor mínimo da carga',
            refereeBonus: 'Bonificación por recomendado',
            referrerBonus: 'Bonificación por recomendante',
        },
        button: {
            search: 'Buscar',
            back: 'Volver',
            add: 'Engadir',
            reset: 'Restablecer',
            edit: 'Editar',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            save: 'Gardar',
            cancel: 'Cancelar',
            action: 'Acción',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
        },
        placeholder: {
            name: 'Nome',
            code: 'Código',
            selectPromotion: 'Seleccionar promoción',
            selectStatus: 'Seleccionar estado',
            promotionCode: 'Código promocional',
            description: 'Descrición',
            maxReferralLimit: 'Límite máximo de recomendacións',
            minChargeValue: 'Valor mínimo da carga',
            refereeBonus: 'Bonificación por recomendado',
            referrerBonus: 'Bonificación por recomendante',
        },
        errors: {
            name: {
                valid: 'Introduza un nome de promoción válido',
            },
            promotionCode: {
                valid: 'Introduza un código promocional válido',
            },
            maxReferralLimit: {
                moreThan: 'O límite máximo de recomendacións debe ser superior a cero',
            },
            referrerBonus: {
                max: 'O valor do Bono do Referidor non pode ser maior que ##MAX_REFERRAL_BONUS##',
            },
            refereeBonus: {
                max: 'O valor do Bono do Referido non pode ser maior que ##MAX_REFERRAL_BONUS##',
            },
        },
    },
    termsConditions: {
        title: 'Termos e condicións: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Termos e condicións',
        manageTermsConditions: 'Xestionar termos e condicións',
        label: {
            enabled: 'Activado',
            disabled: 'Desactivado',
            name: 'Nome',
            description: 'Descrición',
            apply_to: 'Aplicar a',
            mandatory_for_user: 'Obrigatorio para o usuario',
            status: 'Estado',
            delete: 'Eliminar',
            content: 'Contido da política',
            yes: 'Si',
            no: 'Non',
            draft: 'Esbozo',
            published: 'Publicado',
        },
        placeholder: {
            name: 'Nome',
            description: 'Descrición',
            select: {
                apply_to: 'Aplicar a',
                status: 'Seleccionar estado',
            },
        },
        columns: {
            name: 'Nome',
            description: 'Descrición',
            applyto: 'Aplicar a',
            mandatory_for_user: 'Obrigatorio',
            status: 'Estado',
            action: 'Acción',
            modified_date: 'Modificado o',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            edit: 'Editar',
            add: 'Engadir',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
        },
        errors: {
            name: {
                valid: 'Introduza un nome válido',
            },
            invalidFormat: 'Suba un formato de imaxe válido',
            common: 'Produciuse un erro, ténteo de novo.',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
        },
    },
    rewardPromotion: {
        title: 'Promocións por recomendacións: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'IV Promoción de recompensas',
        manageRewardPromotion: 'Xestionar IV Promoción de recompensas',
        label: {
            name: 'Nome',
            code: 'Código',
            valuesPerkwh: 'Valores por kWh',
            monetoryValue: 'Valor monetario',
            redemptionBlock: 'Bloque de troco',
            createdDate: 'Data de creación',
            status: 'Estado',
            enabled: 'Activado',
            disabled: 'Desactivado',
            action: 'Acción',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            promotionCode: 'Código promocional',
            description: 'Descrición',
            expired: 'Caducado',
            locationApplicable: 'Localización de carga aplicable',
            voltsPerkwh: 'Voltios por kWh',
            confirmation: 'Confirmación',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            add: 'Engadir',
            edit: 'Editar',
            reset: 'Restablecer',
            delete: 'Eliminar',
            enable: 'Activar',
            disable: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            uncheckConfirmMesage:
                'Ao desmarcar esta caixa, eliminaranse todas as localizacións de carga asociadas a esta promoción. Seguro que quere eliminala?',
        },
        placeholder: {
            name: 'Nome',
            code: 'Código',
            selectPromotion: 'Seleccionar promoción',
            selectStatus: 'Seleccionar estado',
            locationApplicable: 'Localización de carga aplicable',
            voltsPerkwh: 'Voltios por kWh',
        },
        errors: {
            name: {
                valid: 'Introduza un nome de promoción válido',
            },
            promotionCode: {
                valid: 'Introduza un código promocional válido',
            },
            monetoryValue: {
                moreThan: 'O valor monetario debe ser superior a cero',
                lessThan: 'O valor monetario debe ser inferior ou igual a 99999,99',
                typeError: 'Introduza un valor monetario válido',
            },
            redemptionPointBlock: {
                moreThan: 'O bloque de troco debe ser superior a cero',
            },
            valuePerKwh: {
                moreThan: 'O valor debe ser superior a cero',
            },
        },
    },
    amenitys: {
        title: 'Servizos: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Servizos',
        manageamenitys: 'Xestionar servizos',
        chargeStationsList: 'Estacións de carga',
        chargeLocation: 'Localizacións de carga',
        amenityTranslationNote:
            'Introduza os detalles do servizo para condutores / usuarios administradores no idioma respectivo da rexión. Se non se introduciron os detalles para un idioma concreto, o sistema mostrará os datos predefinidos.',
        label: {
            enabled: 'Activado',
            disabled: 'Desactivado',
            name: 'Nome',
            imageUpload: 'Icona (34 X 34)',
            language: 'Idioma',
            image: 'Icona',
            description: 'Descrición',
            default_search: 'Busca predefinida',
            status: 'Estado',
            delete: 'Eliminar',
            csvFile: 'Ficheiro CSV',
            importAmenityHeader: 'Importar servizos',
            chargeLocation: {
                name: 'Nome',
                type: 'Tipo',
                address: 'Enderezo',
                city: 'Cidade',
                postal_code: 'Código postal',
                modifiedDate: 'Data de modificación',
                action: 'Acción',
            },
            charge_station_name: 'Charge_Station_Name',
            charge_point: 'Charge_Point',
            charge_location_name: 'Charge_Location_Name',
            latitude: 'Latitude',
            longitude: 'Lonxitude',
            location_address: 'Location_Address',
            amenities: 'Servizos',
            amenity_type: 'Tipo de servizo',
        },
        placeholder: {
            name: 'Nome',
            description: 'Descrición',
            file: 'Seleccionar ficheiro CSV',
            select: {
                status: 'Seleccionar estado',
                amenity_type: 'Seleccionar tipo',
            },
        },
        columns: {
            name: 'Nome',
            description: 'Descrición',
            status: 'Estado',
            action: 'Acción',
            amenity_type: 'Tipo',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            edit: 'Editar',
            add: 'Engadir',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
            disable: 'Desactivar',
            enable: 'Activar',
            import: 'Importar',
        },
        errors: {
            common: 'Produciuse un erro, ténteo de novo.',
            name: {
                valid: 'Introduza un nome válido.',
            },
            image: {
                fileType: "Pódense cargar ficheiros con extensión '.jpg', '.png', '.svg' e '.jpeg'.",
                dimensions: 'A icona debe ter unha dimensión de 34 X 34',
                required: 'Icona é un campo obrigatorio',
            },
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
        },
    },
    vehicle: {
        title: 'Vehículo: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Vehículos',
        columns: {
            name: 'Nome',
            registerNo: 'N.º de rexistro',
            make: 'Marca',
            model: 'Modelo',
            chargeType: 'Tipo de carga',
            batteryCapacity: 'Capacidade da batería',
            consumption: 'Consumo',
        },
        placeholder: {
            nameEmail: 'Nome / Correo electrónico',
            makeModelRegistrationNo: 'Marca / Modelo / N.º de rexistro',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
        },
    },
    incompleteSessions: {
        title: 'Sesións incompletas: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Sesións incompletas',
        placeholder: {
            nameOrEmail: 'Nome / Correo electrónico',
            locationOrStation: 'Localización/Estación',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            status: 'Seleccionar estado',
            comment: 'Introduza os seus comentarios',
        },
        label: {
            invalid: 'Non válido',
            generateCDR: 'Xerar CDR',
            totalEnergy: 'Enerxía total',
            totalCost: 'Custo total',
            comment: 'Introduza os seus comentarios',
            cancelCDR: 'Cancelar CDR',
        },
        columns: {
            name: 'Nome',
            location: 'Localización',
            sessionId: 'ID de sesión',
            startDate: 'Data de inicio',
            modifiedDate: 'Data de modificación',
            time: 'Hora',
            energy: 'Enerxía </br> (kWh)',
            cost: 'Custo',
            status: 'Estado',
            action: 'Acción',
        },
        button: {
            action: 'Acción',
            generateCDR: 'Xerar CDR',
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Gardar',
            cancel: 'Cancelar',
            yes: 'Si',
            no: 'Non',
            cancelCDR: 'Cancelar CDR',
        },
        error: {
            max: 'Máximo 250 caracteres permitidos',
        },
        message: {
            cancelCDRMessage: 'Seguro que quere cancelar a sesión?',
            cancelBulkCDRMessage: 'Seguro que quere cancelar a sesión para os rexistros seleccionados?',
            selectCDR: 'Seleccione sesións incompletas',
        },
    },
    ocpiSessions: {
        title: 'Sesións OCPI: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Sesións',
        placeholder: {
            nameOrEmail: 'Nome / Correo electrónico',
            locationOrStation: 'Localización/Estación',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            status: 'Seleccionar estado',
            comment: 'Escriba os seus comentarios',
        },
        columns: {
            name: 'Nome',
            location: 'Localización',
            sessionId: 'ID de sesión',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            time: 'Hora',
            energy: 'Enerxía </br> (kWh)',
            cost: 'Custo',
            status: 'Estado',
            action: 'Acción',
            vehicleNumber: 'Número de vehículo',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            complete: 'Completar',
        },
        label: {
            complete: 'Completar',
            completeSessions: 'Completar sesións de carga',
        },
        message: {
            completeConfirmMessage: 'Quere completar a sesión de carga?',
            stopBulkSessionsMessage: 'Quere completar as sesións de carga seleccionadas?',
            selectSession: 'Seleccione as sesións de carga',
        },
    },
    organisation: {
        title: 'Xestionar organización: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Organización',
        manageOrganisation: 'Xestionar organización',
        label: {
            name: 'Nome',
            description: 'Descrición',
            address: 'Enderezo',
            city: 'Cidade',
            county: 'Condado',
            postal_code: 'Código postal',
            contact_person: 'Persoa de contacto',
            email: 'Correo electrónico',
            phone_number: 'Número de teléfono',
            payment_mode: 'Modo de pagamento',
            payment_schedule: 'Calendario de pagamentos',
            user_group_ids: 'Grupos de usuarios',
            enabled: 'Activado',
            disabled: 'Desactivado',
            amount: 'Límite de crédito',
            po_number: 'Número de orde de pedido',
            finance_account_number: 'Número de conta de financiamento',
            account_contact_email: 'Correo electrónico de contacto da conta',
            remaining_credit: 'Crédito restante (%)',
            remoteChargePassword: 'Contrasinal de inicio de carga remota',
            is_deleted: 'Elimínase',
            yes: 'Si',
            deleted: 'Eliminado',
            dailySpendLimit: 'Límite de gasto diario',
            weeklySpendLimit: 'Límite de gasto semanal',
            monthlySpendLimit: 'Límite de gasto de mes natural',
            defaultSpendLimitGroup: 'Grupo de límite de gasto predefinido',
            updateSpendLimitAssociation: 'Asociación de grupo de límite de gasto',
            promotionUpdate: 'Actualización da promoción',
            currentPromotion: 'Promoción actual',
            newPromotion: 'Nova promoción',
        },
        placeholder: {
            name: 'Nome',
            name_or_email_or_contact_person: 'Nome / Persoa de contacto / Correo electrónico',
            description: 'Descrición',
            address: 'Enderezo',
            city: 'Cidade',
            county: 'Condado',
            postal_code: 'Código postal',
            contact_person: 'Persoa de contacto',
            email: 'Correo electrónico',
            phone_number: 'Número de teléfono',
            select: {
                status: 'Seleccionar estado',
                payment_mode: 'Seleccionar modo de pagamento',
                payment_schedule: 'Seleccionar o calendario de pagamentos',
                user_group_ids: 'Seleccionar grupos de usuarios',
            },
            amount: 'Límite de crédito',
            po_number: 'Número de orde de pedido',
            finance_account_number: 'Número de conta de financiamento',
            remaining_credit: 'Crédito restante (%)',
            remoteChargePassword: 'Contrasinal de inicio de carga remota',
            enableSpendLimit: 'Activar límite de gasto',
            defaultSpendLimitGroup: 'Seleccionar grupo de límite de gasto predefinido',
            selectCurrentPromotion: 'Seleccionar promoción actual',
            selectNewPromotion: 'Seleccionar promoción nova',
        },
        columns: {
            name: 'Nome',
            contact_Person: 'Persoa de contacto',
            email: 'Correo electrónico',
            payment_mode: 'Modo de pagamento',
            payment_schedule: 'Calendario de pagamentos',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            remote_charge_password: 'Contrasinal de inicio de carga remota',
            promotion: 'Promoción',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            edit: 'Editar',
            add: 'Engadir',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
            enable: 'Activar',
            disable: 'Desactivar',
            permission: 'Permiso API',
            assignSpendLimitGroup: 'Asignar grupo de límite de gasto',
        },
        errors: {
            name: {
                valid: 'Introduza un nome válido',
            },
            contact_person: {
                valid: 'Introduza unha persoa de contacto válida',
            },
            email: {
                required: 'Introduza o enderezo de correo electrónico',
                email: 'Introduza un enderezo de correo electrónico válido',
            },
            phoneNo: {
                required: 'Introduza o número de teléfono',
                match: 'Introduza un número de teléfono válido',
            },
            amount: {
                moreThan: 'O importe debe ser superior a 0',
                maxcredit: 'Acadouse o límite máximo para o crédito da conta',
            },
            po_number: {
                valid: 'Introduza un número de orde de pedido válido',
            },
            finance_account_number: {
                valid: 'Introduza un número de conta financeira válido',
            },
            account_contact_email: {
                required: 'Introduza polo menos un enderezo de correo electrónico',
                maxLimit: 'Acadouse o límite máximo de enderezos de correo de contacto de conta',
            },
            remaining_credit: {
                match: 'Introduza un crédito restante válido',
                maxCredit: 'O valor máximo do crédito restante non debe ser superior a 100',
                minCredit: 'O valor mínimo do crédito restante non debe ser inferior a 0',
            },
            value: {
                moreThan: 'O valor debe ser superior a 0',
                lessThan: 'O valor debe ser inferior ou igual a 5000',
                number: 'O valor debe ser un número',
                lessThanWeekly: 'O valor debe ser inferior ou igual ao límite de gasto semanal',
                lessThanMonthly: 'O valor debe ser inferior ou igual ao límite de gasto mensual',
            },
            spend_limit: {
                moreThan: 'O límite de gasto semanal debe ser superior ao límite de gasto diario',
                lessThan: 'O límite de gasto diario debe ser inferior ao límite de gasto semanal',
            },
            address: 'mínimo 10 caracteres permitidos',
            addressValid: 'Introduza un enderezo válido',
            user_group: {
                required: 'Seleccione polo menos un grupo de usuarios',
            },
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            assignAllDriversToDefaultGroup:
                'Quere asignar todos os condutores desta organización ao grupo de límite de gasto predefinido?',
            updatePromotionConfirmMessage:
                'Seguro que quere actualizar a promoción para as organizacións seleccionadas?',
            selectOneRecord: 'Seleccione polo menos unha organización para actualizar a promoción',
            promotionAssignMessage: 'A nova promoción asignarase ás seguintes organizacións:',
        },
        permission: {
            header: 'Permiso API',
            label: {
                description: 'Descrición',
                action: 'APIs',
            },
        },
    },
    transactionLogs: {
        title: 'Rexistro de transaccións: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Rexistros de transaccións',
        placeholder: {
            page: 'Seleccionar páxina',
            email: 'Enderezo de correo electrónico',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            fieldName: 'Nome do campo',
            content: 'Contido',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
        },
        label: {
            tableName: 'Nome da táboa',
            fieldName: 'Nome do campo',
            oldValue: 'Valor antigo',
            newValue: 'Valor novo',
            user: 'Usuario',
            logDate: 'Data de rexistro',
            action: 'Acción',
            goToPage: 'Ir á páxina',
        },
    },
    organisationAccountBalance: {
        title: 'Saldo da conta da organización: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Saldo da conta da organización',
        manageUser: 'Xestionar o saldo da conta da organización',
        columns: {
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito dispoñible',
            unbilledAmount: 'Importe non facturado',
            name: 'Nome',
            contact_Person: 'Persoa de contacto',
            email: 'Correo electrónico',
            payment_mode: 'Modo de pagamento',
            payment_schedule: 'Calendario de pagamentos',
            balance: 'Saldo',
            status: 'Estado',
            action: 'Acción',
            refund: 'Modificar saldo da conta',
        },
        placeholder: {
            name: 'Nome / Persoa de contacto / Correo electrónico',
            description: 'Comentario',
            amount: 'Introduza o importe de crédito/débito',
            select: {
                status: 'Seleccionar estado',
                payment_mode: 'Modo de pagamento',
                payment_schedule: 'Calendario de pagamentos',
            },
            invoice: 'Seleccionar factura',
        },
        label: {
            description: 'Comentario',
            amount: 'Introduza o importe de crédito/débito',
            payment_settlement: 'Modificación do saldo - Solicitude',
            enabled: 'Activado',
            disabled: 'Desactivado',
            invoice: 'Factura',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            save: 'Gardar',
            add: 'Engadir',
            edit: 'Editar',
            reset: 'Restablecer',
            action: 'Acción',
            send_for_approval: 'Enviar para aprobación',
            accept: 'Aceptar',
        },
        errors: {
            amount: {
                moreThan: 'O importe debe ser maior/menor que 0',
                maxcredit: 'Acadouse o límite máximo para o crédito da conta',
                maxdebit: 'Acadouse o límite máximo para o débito en conta',
            },
        },
    },
    driverAward: {
        rewardTitle:
            'Saldo de recompensas - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        approvalRequest:
            'Aprobacións de saldos de recompensas - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        rewards: 'Saldo de recompensas',
        approvalRequests: 'Aprobacións de saldos de recompensas',
        label: {
            name: 'Nome',
            email: 'Correo electrónico',
            iVRewardPromotion: 'IV Promoción de recompensas',
            balance: 'Saldo',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activado',
            disabled: 'Desactivado',
            location: 'Localización',
            date: 'Data',
            energy: 'Enerxía (kWh)',
            cost: 'Custo',
            rewardPoint: 'Punto de recompensa',
            rewardSettelemant: 'Liquidación de recompensas',
            description: 'Descrición',
            credit: 'Crédito',
            debit: 'Débito',
            iVRewardSettelemant: 'Recompensas - Liquidación',
            amount: 'Importe',
            request_by: 'Solicitado por',
            request_date: 'Solicitado o',
            review_by: 'Revisado por',
            review_date: 'Revisado o',
            review_comment: 'Comentarios do revisor',
            approvalRequest: 'Solicitude de aprobación',
            enterComments: 'Introduza os seus comentarios',
            transaction_date: 'Data da transacción',
            debit_credit: 'Débito/Crédito',
            type: 'Tipo',
            requested_by_comment: 'Solicitado por Comentarios',
            volts: 'Voltios',
            commentsFrom: 'Comentarios de',
            approve: 'Aprobar',
            decline: 'Rexeitar',
            federatedAccount: 'Tipo de conta federada',
        },
        placeholder: {
            nameOrEmail: 'Nome / Correo electrónico',
            selectIVAwardPromotion: 'Seleccione IV Promoción de premios',
            selectStatus: 'Seleccionar estado',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            description: 'Descrición',
            volts: 'Voltios',
            enterComments: 'Introduza os seus comentarios',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Gardar',
            cancel: 'Cancelar',
            decline: 'Rexeitar',
            approve: 'Aprobar',
            send_for_approval: 'Enviar para aprobación',
        },
        errors: {
            type: {
                required: 'Crédito ou débito da liquidación',
            },
            volts: {
                typeError: 'Introduza voltios válidos',
                moreThan: 'Os voltios deben ser superiores/inferiores a 0',
            },
            status: {
                selectApprovalOrReject: 'Aprobe ou rexeite esta solicitude.',
            },
        },
    },
    organisationdashboard: {
        title: 'Panel da organización: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Panel da organización',
        dashboard: 'Panel',
        label: {
            filter: 'Filtrar',
            organisation: 'Organización',
            selectOrganisations: 'Seleccionar organizacións',
            dateRange: 'Intervalo de datas',
            driverGroup: 'Grupos de condutores',
            drivers: 'Condutor/vehículo',
            selectDriver: 'Seleccionar condutor/vehículo',
            selectDriverGroup: 'Seleccionar grupos de condutores',
            month: 'Mes',
            year: 'Ano',
            day: 'Día',
            week: 'Semana',
            userSessionTitle: 'Sesións de condutores',
            userSessions: 'Sesións de condutores',
            totalIncomeTitle: 'Suma de ingresos',
            income: 'Ingresos',
            energy: 'Enerxía',
            energyTitle: 'Suma de enerxía (kWh)',
            selectAll: 'Seleccionar todo',
            totalRFIDCards: 'Total tarxetas RFID',
            available: 'Dispoñible',
            allocated: 'Asignadas',
            duplicate: 'Duplicar',
            disabled: 'Desactivadas',
            rfid: 'RFID',
            totalDriverAccounts: 'Total de contas de condutores',
            driver: 'Condutores',
            enabled: 'Activado',
            pending: 'Pendente',
            deleted: 'Eliminado',
            topTenDriverVehicles: 'Os 10 condutores/vehículos máis utilizados',
            driverAccount: 'Condutor',
            vehicle: 'Vehículo',
            driverName: 'Nome do condutor',
            vehicleNumber: 'Número de vehículo',
            kwhUsage: 'Uso de kWh',
            dateRangeLabel: 'Intervalo de datas:',
            both: 'Ambos',
            nameorvehicleno: 'Nome /N.º de vehículo',
            type: 'Tipo',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Limpar',
            syncData: 'Sincronizar datos',
            search: 'Buscar',
            reset: 'Restablecer',
        },
    },
    organisationtransactions: {
        headerTitle:
            'Transaccións da organización - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        invoiceHeader:
            'Detalles da factura ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        invoiceTitle: 'Detalles da factura',
        title: 'Transaccións da organización',
        transaction: 'Transacción',
        columns: {
            location: 'Localización',
            date: 'Data',
            time: 'Hora',
            cost: 'Custo',
            energy: 'Enerxía',
            action: 'Acción',
            remark: 'Observacións',
            amount: 'Importe',
            closing: 'Pechando',
            transaction: 'ID de transacción',
            name: 'Nome',
            credit: 'Crédito',
            debit: 'Débito',
            vehicleNumber: 'Número de vehículo',
            invoiceNumber: 'Número de factura',
            comment: 'Comentario',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        form: {
            charge: 'Cargando',
            payment: 'Pagamento',
            month: 'Mes',
        },
        label: {
            exportAll: 'Exportar todo',
            amount: 'Importe',
            driverName: 'N.º de condutor/vehículo',
            station: 'Estación',
            kwh: 'kWh',
            price_per_kwh: 'Prezo/kWh',
            net_value: 'Valor neto',
            vat_rate: 'Taxa de IVE',
            gross_value: 'Valor bruto',
            totalBeforeVAT: 'Total antes do IVE',
            VatAt: ' IVE a',
            VatRate: 'Taxa de IVE:',
            totalNetAmount: 'Importe neto total',
            subTotal: 'Subtotal',
            adjustedAmount: 'Importe axustado',
            grandTotal: 'Total xeral',
            totalFee: ' Taxa total',
            invoiceNumber: 'Número de factura',
            invoiceDate: 'Data da factura',
            transaction: 'ID de transacción',
            name: 'Nome',
            date: 'Data',
            publicCardId: 'ID de tarxeta pública',
            stationId: 'ID de estación',
            transactionStartDate: 'Data de inicio da transacción',
            transactionEndDate: 'Data de fin da transacción',
            stationAddress: 'Enderezo da estación',
            driverAccountId: 'ID da conta do condutor',
            vat_amount: 'Importe do IVE',
            stationName: 'Nome da estación',
            status: 'Estado',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Volver',
            export: 'Exportar',
        },
        placeholder: {
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            startDateFrom: 'Data de inicio desde',
            startDateTo: 'Data de inicio ata',
            select: {
                organisation: 'Seleccionar organización',
                invoice: 'Seleccionar número de factura',
            },
        },
        message: {
            noDataToExport: 'Non hai datos para exportar.',
            organisation: {
                required: 'Seleccione unha organización',
            },
            selectRecordToExport: 'Seleccione os rexistros que desexa exportar.',
        },
    },
    driverVehicleAccount: {
        title: 'Contas de vehículo/condutor: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Contas de vehículo/condutor',
        managedriver: 'Xestionar condutor/vehículo',
        importHeader: 'Cargar novas contas con tarxetas RFID',
        importUpdateStatusHeader: 'Activar/Desactivar contas',
        importUpdateSpendGroupAssociation: 'Actualizar a asociación de grupo de límite de gasto do condutor',
        placeholder: {
            name: 'Nome / Correo electrónico / N.º de vehículo',
            rfidCardNo: 'Nº de tarxeta RFID',
            driverGroups: 'Seleccionar grupos de condutores',
            status: 'Seleccionar estado',
            first_name: 'Nome',
            last_name: 'Apelidos',
            email: 'Enderezo de correo electrónico',
            vehicle_no: 'Vehículo n.º',
            driverGroup: 'Seleccionar grupos de condutores',
            accountType: 'Seleccionar tipo de conta',
            publicRFIDCardNo: 'Introduza o n.º de tarxeta RFID pública',
            languagePreference: 'Preferencias de idioma',
        },
        label: {
            name: 'Nome',
            email: 'Correo electrónico',
            vehicleNo: 'Vehículo n.º',
            group: 'Grupo',
            createdDate: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activado',
            disabled: 'Desactivadas',
            cancelled: 'Cancelado',
            deleted: 'Eliminado',
            delete: 'Eliminar',
            first_name: 'Nome',
            last_name: 'Apelidos',
            vehicle_no: 'Vehículo n.º',
            driverGroup: 'Grupos de condutores',
            accountType: 'Tipo de conta',
            assignRFIDCard: 'Asignar tarxeta RFID',
            rfidCard: 'Tarxeta RFID',
            publicRFIDCardNo: 'Introduza o n.º de tarxeta RFID pública',
            assign: 'Asignar',
            allocatedRFIDCards: 'Tarxetas RFID asignadas',
            file: 'Ficheiro CSV',
            clickHere: 'Faga clic aquí',
            downloadTemplate: 'para descargar o modelo',
            errosInImportedFile: 'Erros',
            driverVehicleNo: 'N.º de condutor/vehículo',
            driverVehicleDetails: 'Datos de condutor/vehículo',
            error: 'Erro',
            pending: 'Pendente',
            card_allocated: 'Tarxeta RFID asignada',
            driver: 'Condutor (conta baseada na aplicación Fleet)',
            vehicle: 'Vehículo (conta baseada en RFID)',
            note: 'Nota: ',
            accountSetupNote:
                'O titular da conta deberá completar a configuración da conta nun prazo de 24 horas a través da aplicación para frotas ##COMPANY_BRAND_NAME## utilizando o contrasinal provisional enviado por correo electrónico.',
        },
        button: {
            import: 'Importar',
            add: 'Engadir',
            search: 'Buscar',
            reset: 'Restablecer',
            edit: 'Editar',
            enable: 'Activar',
            disable: 'Desactivar',
            delete: 'Eliminar',
            yes: 'Si',
            no: 'Non',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            assignRFIDCard: 'Asignar tarxeta RFID',
            assign: 'Asignar',
            action: 'Acción',
            done: 'Feito',
            sendEmail: 'Enviar correo electrónico',
            enableDisableAccounts: 'Activar/Desactivar contas',
            export: 'Exportar',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            sendMailConfirmMessage: 'Seguro que quere enviar o correo electrónico?',
            mailSentSuccessMessage: 'Correo electrónico enviado correctamente.',
        },
        errors: {
            invalidEmail: 'Introduza un enderezo de correo electrónico válido.',
            invalidFirstName: 'Introduza un nome válido.',
            invalidLastName: 'Introduza uns apelidos válidos.',
            invalidVehicleNo: 'Introduza un n.º de vehículo válido',
            common: 'Produciuse un erro, ténteo de novo.',
        },
        account_type: {
            driver: 'Condutor',
            vehicle: 'Vehículo',
        },
        columns: {
            public_rfid_card_no: 'N.º de tarxeta',
            allocatedBy: 'Asignada por',
            allocatedDate: 'Data asignación',
            status: 'Estado',
        },
    },
    chargingHistory: {
        header: 'Sesións de carga - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        title: 'Sesións de carga',
        label: {
            exportAll: 'Exportar',
            location: 'Localización',
            date: 'Data',
            milesAdded: 'Quilómetros engadidos',
            time: 'Hora',
            cost: 'Custo',
            energy: 'Enerxía',
            action: 'Acción',
            remark: 'Observacións',
            name: 'Nome',
            vehicleNo: 'Vehículo n.º',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Volver',
        },
        placeholder: {
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            startDateFrom: 'Data de inicio desde',
            startDateTo: 'Data de inicio ata',
            driver: 'Nome / Correo electrónico / N.º de vehículo',
            selectDriverGroup: 'Seleccionar grupos de condutor/vehículo',
        },
        errors: {
            noDataToExport: 'Non hai datos para exportar.',
            selectRecordToExport: 'Seleccione os rexistros que desexa exportar.',
            common: 'Produciuse un erro, ténteo de novo.',
        },
    },
    paymentHistory: {
        header: 'Historial de pagamento - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        title: 'Historial de pagamento',
        invoiceHeader:
            'Detalles da factura ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        invoiceTitle: 'Detalles da factura',
        label: {
            remark: 'Observacións',
            credit: 'Crédito',
            debit: 'Débito',
            closing: 'Pechando',
            transaction: 'ID de transacción',
            name: 'Nome',
            date: 'Data',
            amount: 'Importe',
            driverName: 'N.º de condutor/vehículo',
            station: 'Estación',
            kwh: 'kWh',
            price_per_kwh: 'Prezo/kWh',
            net_value: 'Valor neto',
            vat_rate: 'Taxa de IVE',
            gross_value: 'Valor bruto',
            totalBeforeVAT: 'Total antes do IVE',
            VatAt: ' IVE a',
            totalFee: ' Taxa total',
            invoiceNumber: 'Número de factura',
            invoiceDate: 'Data da factura',
            publicCardId: 'ID de tarxeta pública',
            stationId: 'ID de estación',
            transactionStartDate: 'Data de inicio da transacción',
            transactionEndDate: 'Data de fin da transacción',
            stationAddress: 'Enderezo da estación',
            driverAccountId: 'ID da conta do condutor',
            vat_amount: 'Importe do IVE',
            stationName: 'Nome da estación',
        },
        csvHeader: {
            transaction: 'Transaction_ID',
            publicCardId: 'Public_Card_ID',
            stationId: 'Station_ID',
            transactionStartDate: 'Transaction_Start_Date',
            transactionEndDate: 'Transaction_End_Date',
            stationAddress: 'Station_Address',
            driverAccountId: 'Driver_Account_ID',
            vat_amount: 'VAT_Amount',
            stationName: 'Station_Name',
            kwh: 'kWh_Delivered',
            price_per_kwh: 'Price_Per_kWh',
            net_value: 'Net_Value',
            vat_rate: 'VAT_Rate',
            gross_value: 'Gross_Value',
            invoiceNumber: 'Invoice_Number',
            driverName: 'Driver_Name',
        },
        placeholder: {
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            export: 'Exportar',
        },
        errors: {
            noDataToExport: 'Non hai datos para exportar.',
            selectRecordToExport: 'Seleccione os rexistros que desexa exportar.',
        },
    },
    configurations: {
        title: 'Configuracións: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Configuracións',
        columns: {
            name: 'Nome',
            value: 'Valor',
            description: 'Descrición',
            system_type: 'Tipo de sistema',
            modifiedBy: 'Modificado por',
            modifiedDate: 'Data de modificación',
            action: 'Acción',
        },
        button: {
            save: 'Gardar',
            cancel: 'Cancelar',
            reset: 'Restablecer',
            search: 'Buscar',
            action: 'Acción',
            edit: 'Editar',
        },
        note: 'AVISO: Cambiar estes axustes de configuración pode afectar significativamente ao desempeño da plataforma. En caso de dúbida, póñase en contacto co administrador do sistema.',
        errors: {
            maxLengthString: 'Introduza un valor cun máximo de',
            maxLengthStringCharacters: 'caracteres',
            maxLengthNUmberCharacters: 'díxitos',
            valueBetween: 'Introduza un valor entre',
            valueGraterThen: 'Introduza un valor igual ou superior a',
            valueMention: 'Indique o valor no intervalo mencionado',
        },
        placeholder: {
            value: 'Introducir valor',
            description: 'Introducir descrición',
            name: 'Nome',
            valueSearch: 'Valor',
            descriptionSearch: 'Descrición',
            referenceCode: 'Código de recomendación',
            systemType: 'Seleccione o tipo de sistema',
        },
        label: {
            value: 'Valor',
            dataType: 'Tipo de datos',
            description: 'Descrición',
            system: 'SISTEMA',
            driver: 'CONDUTOR',
            admin: 'ADMIN',
            referenceCode: 'Código de recomendación',
        },
    },
    rfidRequests: {
        title: 'Solicitudes de tarxeta RFID - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        header: 'Solicitudes de tarxeta RFID',
        placeholder: {
            nameEmail: 'Nome / Correo electrónico',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            publicCardNo: 'Introduza o nº de tarxeta pública',
            enterComments: 'Introduza os seus comentarios',
            status: 'Seleccionar estado',
            publicRFIDCardNo: 'Introduza o n.º de tarxeta RFID pública',
            scanReqQR: 'Escanee o código QR impreso na carta',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Gardar',
            cancel: 'Cancelar',
            add: 'Engadir',
            done: 'Feito',
            action: 'Acción',
            assign: 'Asignar',
            downloadPdf: 'Descargar PDF de solicitudes',
            downloadPdfSelected: 'Descargar PDF para solicitudes seleccionadas',
            downloadPendingApprovedPdf: 'Descargar todos os PDF de solicitudes aprobadas e pendentes',
        },
        columns: {
            name: 'Nome',
            email: 'Correo electrónico',
            requestedDate: 'Data solicitada',
            noofCardReq: 'N.º de tarxeta solicitada',
            noofCardAllocated: 'N.º de tarxeta asignada',
            requestStatus: 'Estado da solicitude',
            status: 'Estado',
            driverStatus: 'Estado do condutor',
            action: 'Acción',
            public_rfid_card_no: 'N.º de tarxeta',
            allocatedBy: 'Asignada por',
            allocatedDate: 'Data asignación',
            federated_account_type: 'Tipo de conta federada',
        },
        label: {
            reviewRequest: 'Solicitude de revisión',
            assignRFID: 'Tarxeta RFID',
            processRFIDRequest: 'Procesar solicitude',
            noofCardRequested: 'N.º de tarxeta solicitada',
            noofCardAllocated: 'N.º de tarxeta asignada',
            approved: 'Aprobar',
            declined: 'Rexeitar',
            publicCardNo: 'Introduza o nº de tarxeta pública',
            enterComments: 'Introduza os seus comentarios',
            requestStatus: 'Estado da solicitude',
            assignRFIDCards: 'Asignar tarxetas RFID',
            publicRFIDCardNo: 'Introduza o n.º de tarxeta RFID pública',
            allocatedRFIDCards: 'Tarxetas RFID asignadas',
            address: 'Enderezo',
            scanReqQR: 'Escanee o código QR impreso na carta',
            name: 'Nome',
            requestId: 'ID da solicitude',
            scanHistory: 'Historial de exploración',
        },
        message: {
            requestProcessed: 'Solicitude procesada correctamente',
        },
        errors: {
            approveReject: 'Aprobe ou rexeite esta solicitude.',
            selectAnyRecord: 'Seleccione polo menos un rexistro para descargar o PDF.',
            reqNumTypeError: 'Introduza un ID de solicitude válido',
        },
        pdfText: {
            dear: 'Estimado/a',
            instavolt: ' ##COMPANY_BRAND_NAME##',
            companyNumber: 'Número de empresa',
            line1: 'Grazas por solicitar a súa tarxeta RFID a través da aplicación ##COMPANY_BRAND_NAME##. Incluímos a súa tarxeta.',
            line2: 'Para activar a súa tarxeta, siga os pasos que se indican a continuación:',
            step1: '1. Iniciar sesión na aplicación',
            step2: '2. No menú, seleccione «»Configuración»',
            step3: '3. Faga clic na opción «As miñas tarxetas RFID»',
            step4: '4. Faga clic no botón «Engadir tarxeta RFID»',
            step5: '5. Introduza o número impreso na tarxeta e prema o botón «»Continuar»',
            step6: '6. A súa tarxeta xa está activada e pode usala para iniciar a próxima sesión de carga',
            line3: 'Sabía que pode gañar recompensas cada vez que cargue? Recibirá un voltio por cada kWh consumido e, cando teña acumulados voltios abondo, poderá trocalos e utilizalos para comprar sesións de carga na rede.',
            line4: 'Grazas por cargar o seu vehículo con nós.',
            line5: 'O equipo de ##COMPANY_BRAND_NAME##',
            line6: 'Fornecemos unha infraestrutura de carga de vehículos eléctricos de primeira clase no Reino Unido',
        },
    },
    RFIDCardFleets: {
        title: 'Tarxetas RFID: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Tarxetas RFID',
        placeholder: {
            name: 'Nome do condutor / Correo electrónico / Número de vehículo',
            manufacturer: 'Fabricante',
            public_card_id: 'ID de tarxeta pública',
            status: 'Seleccionar estado',
            mifare_uid: 'UID de Mifare',
        },
        label: {
            name: 'Nome',
            manufacturer: 'Fabricante',
            part_id: 'ID de terceiros',
            public_card_id: 'ID de tarxeta pública',
            private_card_id: 'ID de tarxeta privada',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activado',
            disabled: 'Desactivadas',
            delete: 'Eliminar',
            remove: 'Eliminar asociación',
            reinstate: 'Restaurar',
            activated: 'Activada',
            available: 'Dispoñible',
            duplicate: 'Duplicar',
        },
        button: {
            search: 'Buscar',
            cancel: 'Cancelar',
            add: 'Engadir',
            assing: 'Asignar tarxeta RFID',
            import: 'Importar ficheiro',
            save: 'Gardar',
            edit: 'Editar',
            reset: 'Restablecer',
            yes: 'Si',
            no: 'Non',
            enabled: 'Activar',
            disabled: 'Desactivar',
            action: 'Acción',
            back: 'Volver',
            enable: 'Activar',
            disable: 'Desactivar',
            getCredentials: 'Obter credenciais',
            delete: 'Eliminar',
            remove: 'Eliminar asociación',
            reinstate: 'Restaurar',
            exportAll: 'Exportar todo',
        },
        message: {
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            removeConfirmMesage: 'Seguro que quere eliminar a asociación da tarxeta RFID a unha conta?',
            reinstateConfirmMessage: 'Seguro que quere restaurar a tarxeta RFID?',
        },
        insert: {
            header: 'Xestionar tarxetas RFID',
            placeholder: {
                manufacturer: 'Nome do fabricante',
                part_id: 'ID de terceiros',
                public_card_id: 'ID de tarxeta pública',
                private_card_id: 'ID de tarxeta privada',
                mifare_uid: 'UID de Mifare',
            },
            label: {
                manufacturer: 'Fabricante',
                part_id: 'ID de terceiros',
                public_card_id: 'ID de tarxeta pública',
                private_card_id: 'ID de tarxeta privada',
                mifare_uid: 'UID de Mifare',
            },
            errors: {
                common: 'Produciuse un erro, ténteo de novo.',
                name: {
                    valid: 'Introduza un nome válido',
                },
                code: {
                    valid: 'Introduza un código válido',
                },
                url: {
                    valid: 'O URL debe ser un URL válido',
                },
            },
        },
        assignCards: {
            header: 'Asignar tarxeta RFID',
            label: {
                driver: 'Condutor/vehículo',
            },
            button: {
                yes: 'Asignar',
                no: 'Cancelar',
            },
            form: {
                driver: 'Condutor/vehículo',
                placeholder: {
                    driver: 'Seleccionar condutor/vehículo',
                },
            },
        },
        disableCards: {
            header: 'Desactivar',
            header2: 'Seguro que quere desactivar?',
            placeholder: {
                comment: 'Escriba un comentario',
            },
            label: {
                comment: 'Comentario',
            },
            button: {
                yes: 'Si',
                no: 'Non',
            },
        },
        importCards: {
            header: 'Importar tarxetas RFID',
            placeholder: {
                file: 'Seleccionar ficheiro CSV',
            },
            label: {
                file: 'Ficheiro CSV',
            },
            button: {
                yes: 'Importar',
                no: 'Cancelar',
            },
            errors: {
                common: 'Produciuse un erro, ténteo de novo.',
                file: {
                    fileType: "Pódense cargar ficheiros con extensión '.csv'.",
                },
            },
        },
        importCardsDetails: {
            header: 'Detalles da importación de tarxetas RFID',
            label: {
                unSuccessfullImport: 'Non se poden importar as seguintes tarxetas',
                successfullImport: 'As seguintes tarxetas importáronse correctamente',
                failerReason: 'Razón do fallo',
                publicCardId: 'ID de tarxeta pública',
            },
            message: {
                defualtErrorMessage: 'Hai un problema ao importar as seguintes tarxetas.',
            },
        },
    },
    myProfile: {
        title: 'O meu perfil: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'O meu perfil',
        subheader: {
            details: 'Datos persoais',
            security: 'Seguranza',
            password: 'Contrasinal',
        },
        label: {
            firstName: 'Nome',
            lastName: 'Apelidos',
            email: 'Correo electrónico',
            phoneNo: 'Número de teléfono',
            currentPassword: 'Contrasinal actual',
            newPassword: 'Novo contrasinal',
            confirmPassword: 'Volver confirmar o contrasinal',
            mfaAuthentication: 'Autenticación 2FA',
            authentication: 'Autenticación',
            securityCode: 'Código de seguranza',
            languagePreference: 'Preferencias de idioma',
        },
        placeholder: {
            firstName: 'Nome',
            lastName: 'Apelidos',
            email: 'Correo electrónico',
            phoneNo: 'Número de teléfono',
            currentPassword: 'Contrasinal actual',
            newPassword: 'Novo contrasinal',
            confirmPassword: 'Volver confirmar o contrasinal',
            securityCode: 'Código de seguranza',
            languagePreference: 'Preferencias de idioma',
        },
        button: {
            save: 'Gardar',
            cancel: 'Cancelar',
            update: 'Actualizar',
            ok: 'Aceptar',
        },
        toast: {
            profileSuccess: 'Perfil actualizado correctamente.',
            profileError: 'O perfil non está actualizado. Ténteo de novo máis tarde.',
            passwordChange: 'Contrasinal modificado correctamente.',
            passwordErr: 'O contrasinal non se modificou correctamente. Ténteo de novo máis tarde.',
            passwordWrong: 'O contrasinal actual é incorrecto.',
            securityStop: 'Detívose a seguranza de autenticación 2FA.',
            error: 'Produciuse un erro. Ténteo de novo máis tarde.',
            securitySetupSuccess: 'A autenticación 2FA configurouse correctamente.',
            securitySetupError: 'A autenticación 2FA non se configurou correctamente. Ténteo de novo máis tarde.',
            securityCodeInvalid: 'Código de seguranza non válido.',
        },
        errors: {
            securityCode: {
                match: 'Introduza un código válido',
                inValid: 'Introduza un código de 6 díxitos',
            },
            password: {
                confirmPasswordMatch: 'O contrasinal novo e o contrasinal de reconfirmación non coinciden.',
            },
        },
    },
    apiCredentials: {
        title: 'Credenciais da API: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Credenciais da API',
        button: {
            generate: 'Xerar token',
            regenerate: 'Volver xerar token',
            yes: 'Si',
            no: 'Non',
        },
        note_no_permission:
            'Non ten dereitos para acceder á API. Póñase en contacto co administrador de ##COMPANY_BRAND_NAME## para obter acceso.',
        note_generte_token:
            'Pode xerar o token facendo clic en «Xerar token» e pode usar ese token para acceder á API.',
        note: 'Pode volver xerar o token facendo clic en «Volver xerar token» e pode usar ese token para acceder á API.',
        label: {
            token: 'Token',
            generate: 'Xerar token',
            regenerate: 'Volver xerar token',
        },
        message: {
            regenerateConfirmMesage:
                'Seguro que desexa volver xerar o token? <br/> Cando se volva xerar, o antigo non será válido e non poderá acceder á API con el.',
            generateConfirmMesage: 'Seguro que quere xerar o token?',
        },
    },
    cookiePolicy: {
        text: 'Este sitio web utiliza cookies para mellorar a experiencia do usuario. Ao usar o noso sitio web, vostede confirma que leu e comprendeu a nosa',
        action: 'Política de cookies',
        iAccept: 'Acepto',
    },
    paymentconfig: {
        title: 'Pagamento - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        header: 'Pagamento',
        processingNote: 'Agarde mentres se procesa a súa transacción',
        purchaseOrderNote: 'Ten un ciclo de facturación ##PAYMENT_SCHEDULE##. A súa próxima data de facturación será: ',
        description: 'Pagamento a ##COMPANY_BRAND_NAME##',
        note: 'O traballo en segundo plano executarase cada semana para liquidar as facturas pendentes polas recargas de VE realizadas polos condutores/vehículos ',
        addReplaceCardNote:
            'Lembre que ao engadir unha tarxeta de pagamento, cargaranse ##CURRENCY_SYMBOL_WITH_VALUE## na súa conta, que se abonarán ao saldo do seu moedeiro de ##COMPANY_BRAND_NAME##.',
        label: {
            currentBalance: 'Saldo actual',
            closingBalance: 'Saldo final',
            availableCredit: 'Crédito dispoñible',
            unbilledAmount: 'Importe non facturado',
            cardTitle: 'Nome que figura na tarxeta',
            cardNumber: 'Número de tarxeta',
            expiry: 'Caducidade',
            note: 'Nota: ',
            CSC: 'CSC',
            cardSecurityCode: '(Código de seguranza da tarxeta)',
            charityDonation: 'Doazón benéfica',
            roundUp: 'Arredondar',
            topUp: 'Recargar',
            expires: 'Caduca',
            charity: 'Organización benéfica',
        },
        placeholder: {
            cardTitle: 'Nome que figura na tarxeta',
            cardNumber: '1234 1234 1234 1234',
            CSC: 'CSC',
            topUpAmount: '00,00',
        },
        button: {
            save: 'Gardar',
            edit: 'Editar',
            replace: 'Substituír',
            back: 'Volver',
            payNow: 'Pagar agora',
        },
        errors: {
            CSC: {
                min: 'Introduza un código de 3 díxitos como mínimo.',
            },
            topupAmount: {
                min: 'O importe da organización benéfica debe ser igual ou superior a 0,1',
            },
            cardNumber: {
                inValid: 'Número de tarxeta non válido',
            },
            commonError: 'Produciuse un erro ao procesar a súa solicitude. Ténteo de novo máis tarde.',
            transactionFailed: 'Produciuse un erro na súa transacción. Ténteo de novo.',
        },
        message: {
            cardSaved: 'Os datos da tarxeta gardáronse correctamente',
        },
    },
    refundRequest: {
        title: 'Aprobacións de retirada de fondos - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        header: 'Aprobacións de retirada de fondos',
        accountInfoNote: 'Información da conta introducida para realizar a retirada de fondos:',
        completeConfirmNote:
            'Complete esta solicitude de retirada de fondos só se aboou na conta bancaria do condutor o valor indicado. Quere continuar?',
        bulkCompleteConfirmNote:
            'Complete estas solicitudes de retirada de fondos só se aboou na conta bancaria do condutor o valor indicado. Quere continuar?',
        declineConfirmNote:
            'Asegúrese de que introduciu un motivo adecuado para rexeitar a solicitude, xa que esta información se transmite ao cliente.  Quere continuar?',
        bulkDeclineConfirmNote:
            'Asegúrese de que introduciu un motivo adecuado para rexeitar as solicitudes, xa que esta información se transmite ao cliente.  Quere continuar?',
        label: {
            name: 'Nome',
            reviewRequest: 'Solicitude de revisión',
            driverName: 'Nome do condutor',
            driverEmail: 'Correo electrónico do condutor',
            requestedDate: 'Data solicitada',
            action: 'Acción',
            amount: 'Importe',
            refundRequested: 'Retirada de fondos solicitada',
            status: 'Estado',
            accountNumber: 'Número de conta',
            sortCode: 'Sort Code',
            enterComments: 'Escribir comentarios',
            pending: 'Pendente',
            closed: 'Pechado',
            complete: 'Completar',
            decline: 'Rexeitar',
            review_by: 'Revisado por',
            review_date: 'Revisado o',
            approvalRequest: 'Aprobar solicitude',
            processRefundRequest: 'Procesar solicitude de retirada de fondos',
            completeRefundRequest: 'Completar solicitude de retirada de fondos',
            bulkCompleteRefundRequest: 'Completar solicitudes de retirada de fondos',
            declineRefundRequest: 'Rexeitar solicitude de retirada de fondos',
            bulkdeclineRefundRequest: 'Rexeitar solicitudes de retirada de fondos',
            export: 'Exportar datos',
            bulk: 'En masa',
        },
        button: {
            decline: 'Rexeitar',
            approve: 'Aprobar',
            reset: 'Restablecer',
            search: 'Buscar',
            complete: 'Completar',
            save: 'Gardar',
            cancel: 'Cancelar',
            yes: 'Si',
            no: 'Non',
        },
        placeholder: {
            selectStatus: 'Seleccionar estado',
            enterComments: 'Escribir comentarios',
            name: 'Nome / Correo electrónico',
        },
        errors: {
            status: {
                selectApprovalOrReject: 'Complete ou rexeite esta solicitude.',
            },
            selectWithdrawalApprovals: 'Seleccione as solicitudes de retirada de fondos',
        },
    },
    termsAndConditionListing: {
        title: 'Termos e condicións - ##COMPANY_BRAND_NAME##: Recarga rápida de vehículos eléctricos no Reino Unido',
        header: 'Termos e condicións',
        noteDetails: '*Os campos obrigatorios teñen que aceptarse para poder usar ou rexistrar unha conta.',
        label: {
            iAggreeToTermsCondition: 'Acepto ',
            note: 'Nota: ',
            termsAndConditions: 'Termos e condicións.',
            reviewUpdatedCondition:
                'Revise e acepte os termos e condicións actualizados que se enumeran a continuación.',
            name: 'Nome',
        },
        button: {
            accept: 'Aceptar',
            next: 'Seguinte',
            cancel: 'Cancelar',
        },
        errors: {
            acceptTermCondition: 'Acepte os * Termos e condicións obrigatorios para poder continuar.',
        },
    },
    adminDashboard: {
        title: 'Inicio: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Panel',
        formtitle: 'Validación de formularios',
        label: {
            filter: 'Filtrar',
            reportTags: 'Etiquetas do informe',
            driverGroup: 'Grupos de condutores',
            selectDriverGroup: 'Seleccionar grupos de condutores',
            selectTags: 'Seleccionar etiquetas',
            dateRange: 'Intervalo de datas',
            month: 'Mes',
            year: 'Ano',
            day: 'Día',
            week: 'Semana',
            userSessionTitle: 'Sesións de condutores',
            userSessions: 'Sesións de condutores',
            totalIncomeTitle: 'Suma de ingresos',
            income: 'Ingresos',
            transactionTitle: 'Media de transaccións',
            transaction: 'Transacción',
            energy: 'Enerxía',
            energyTitle: 'Suma de enerxía (kWh)',
            failedPaymentTitle: 'Número de pagamentos con erro',
            failedPayment: 'Erro de pagamento',
            driverCountTitle: 'Recontos de condutores',
            driver: 'Condutor',
            accumulatedVolts: 'Voltios acumulados',
            claimedVolts: 'Voltios reclamados ',
            outStandingFailPayment: 'Erro de pagamento pendente',
            outStandingFailedPaymentTitle: 'Erros de pagamento pendentes',
            voltsLiability: 'Responsabilidade de Voltios',
            voltsAccumulatedTitle: 'Voltios acumulados',
            volts: 'Voltios',
            voltsClaimedTitle: 'Voltios reclamados',
            lapsedVolts: 'Voltios caducados',
            totalNoOfDriverAccount: 'Número total de contas de condutores',
            enabled: 'Activado',
            disabled: 'Desactivadas',
            badDebtor: 'Debedor moroso',
            cancelled: 'Cancelado',
            deleted: 'Eliminados',
            fake_account: 'Conta falsa',
            numberOfReferees: 'Número de recomendados',
            numberOfReferrers: 'Número de recomendantes',
            referralPayment: 'Pagamentos por recomendación (recomendante + recomendado)',
            referrer: 'Recomendante',
            referee: 'Recomendado',
            moneySpent: 'Cartos gastados só polos recomendados',
            referralBonus: 'bonificación por recomendación',
            referralPromotion: 'Promoción de recomendación',
            overnightAutomated: 'Automatización nocturna',
            customerManual: 'Manual de cliente',
            pending: 'Pendente',
            patnerPromoClicksCount: 'Reconto de clics de promocións para socios ',
            clicksCount: 'Reconto de clics',
            clicksCountMessage:
                'Seleccione unha ou varias opcións para mostrar o reconto de clics de promocións de socios',
            individualDrivers: 'Contas activadas de condutores',
            organisationDrivers: 'Contas activadas de organizacións',
            individualAndOrgDriverCount: 'Contas activadas: Condutores e organizacións',
            alerts: 'Alertas',
            alertsCountTitle: 'Reconto de alertas',
            premiumSubscriptions: 'Subscricións Premium',
            activeSubscriptions: 'Total de subscricións Premium activas',
            newSubscriptions: 'Novas subscricións',
            cancelledSubscriptions: 'Subscricións canceladas',
            subscriptions: '(Subscricións)',
        },
        placeholder: {
            patnerPromotions: 'Seleccione unha ou varias promocións de socios para mostrar os datos',
        },
        button: {
            apply: 'Aplicar',
            clear: 'Limpar',
            syncData: 'Sincronizar datos',
        },
    },
    footer: {
        version: 'Versión',
        copyRightText: 'Todos os dereitos reservados',
    },
    cardReader: {
        title: 'Lectores de tarxetas: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Lectores de tarxetas',
        manageCardReader: 'Xestionar lector de tarxetas',
        importHeader: 'Importar lectores de tarxetas',
        button: {
            import: 'Importar',
            add: 'Engadir',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            action: 'Acción',
            delete: 'Eliminar',
            search: 'Buscar',
            reset: 'Restablecer',
            disable: 'Desactivar',
            duplicate: 'Duplicar',
            active: 'Activo',
            chargeStation: 'Estacións de carga',
            yes: 'Si',
            no: 'Non',
            claimCardReader: 'Reclama lectores de tarxetas non asignados',
            claim: 'Reclamación',
        },
        label: {
            description: 'Descrición',
            latitude: 'Latitude',
            longitude: 'Lonxitude',
            serialNumber: 'Número de serie',
            endPoint: 'Extremo',
            createdDate: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            csvFile: 'Ficheiro CSV',
            clickHere: 'Faga clic aquí',
            downloadTemplate: 'para descargar o modelo',
            evse_id: 'ID EVSE',
            error: 'Erro',
            errorDetail: 'Detalles do erro',
            failureReason: 'Motivo do fracaso',
            id: 'ID do lector de tarxetas',
        },
        placeholder: {
            description: 'Descrición',
            latitude: 'Latitude',
            longitude: 'Lonxitude',
            serialNumber: 'Número de serie',
            endPoint: 'Anular extremo',
            selectStatus: 'Seleccionar estado',
        },
        errors: {
            latitude: {
                min: 'A latitude debe estar entre -90,0 e 90,0',
                max: 'A latitude debe estar entre -90,0 e 90,0',
                number: 'A latitude debe ser un número',
            },
            longitude: {
                min: 'A lonxitude debe estar entre -180,0 e 180,0',
                max: 'A lonxitude debe estar entre -180,0 e 180,0',
                number: 'A lonxitude debe ser un número',
            },
            serial_number: {
                valid: 'Introduza un número de serie válido',
            },
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            duplicateConfirmMesage: 'Seguro que quere duplicar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            activeConfirmMesage: 'Seguro que quere activar?',
        },
        assign: {
            header: 'Estacións de carga',
            headerModal: 'Estación de carga',
            placeholder: {
                name: 'Introduza o nome',
                address: 'Enderezo',
                tags: 'Seleccionar etiquetas',
            },
            label: {
                add: 'Engadir',
                address: 'Enderezo',
                city: 'Cidade',
                name: 'Nome',
                type: 'Tipo',
                physical_reference: 'Referencia física',
                postcode: 'Código postal',
                action: 'Acción',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Seguro que quere eliminar?',
            },
        },
    },
    cardScheme: {
        title: 'Esquemas de tarxetas: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Esquemas de tarxetas',
        manageCardScheme: 'Xestionar esquema de tarxetas',
        label: {
            TransIdSeed: 'Valor de inicio de ID de transacción',
            keybEncrKey: 'Clave de cifrado de KeyB',
            transIdEncrKey: 'Clave de cifrado de ID de transacción',
            emspCode: 'Código de EMSP',
            endPoint: 'Extremo',
            createdDate: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            enabled: 'Activado',
            disabled: 'Desactivadas',
        },
        button: {
            import: 'Importar',
            add: 'Engadir',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            edit: 'Editar',
            action: 'Acción',
            delete: 'Eliminar',
            search: 'Buscar',
            reset: 'Restablecer',
            disable: 'Desactivar',
            enable: 'Activar',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            enableConfirmMesage: 'Seguro que quere activar?',
        },
        placeholder: {
            emspCode: 'Código de EMSP',
            keybEncrKey: 'Clave de cifrado de KeyB',
            transIdEncrKey: 'Clave de cifrado de ID de transacción',
            TransIdSeed: 'Valor de inicio de ID de transacción',
        },
        errors: {
            emsp_code: {
                valid: 'Introduza un código de EMSP válido',
            },
            transaction_id_seed: {
                valid: 'Introduza un valor de inicio de ID de transacción válido',
                min: 'O valor de inicio de ID de transacción non pode ser inferior a 0',
                max: 'Acadouse o límite máximo do valor de inicio de ID de transacción',
            },
        },
    },
    fleetProfile: {
        orgProfile: 'Perfil da organización',
        message: {
            success: 'O perfil da organización actualizouse correctamente',
        },
    },
    dataAggregator: {
        title: 'Agregadores de datos: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Agregadores de datos',
        button: {
            add: 'Engadir',
            search: 'Buscar',
            reset: 'Restablecer',
            enable: 'Activar',
            disable: 'Desactivar',
            edit: 'Editar',
            yes: 'Si',
            no: 'Non',
            action: 'Acción',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            syncDataAggregatorAPIKeys: 'Sincroniza as claves API cos plans de uso',
        },
        placeholder: {
            name: 'Nome',
            status: 'Seleccionar estado',
        },
        label: {
            enabled: 'Activado',
            disabled: 'Desactivadas',
            name: 'Nome',
            party_id: 'ID de terceiros',
            country_code: 'Código do país',
            version_url: 'URL de versión',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
        },
        message: {
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
        },
        insert: {
            header: 'Xestionar agregadores de datos',
            errors: {
                common: 'Produciuse un erro, ténteo de novo.',
                name: {
                    valid: 'Introduza un nome de agregador de datos válido',
                },
                party_id: {
                    valid: 'Introduza un ID de terceiros válido',
                },
                country_code: {
                    valid: 'Introduza un código de país válido',
                },
                version_url: {
                    url: 'O URL da versión debe ser un URL válido',
                },
                token: {
                    valid: 'Introduza un token válido',
                },
            },
            placeholder: {
                name: 'Nome',
                party_id: 'ID de terceiros',
                country_code: 'Código do país',
                version_url: 'URL de versión do agregador de datos',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                emsp: 'EMSP',
                access_group: 'Grupo de acceso',
                usagePlan: 'Plan de uso',
            },
            label: {
                name: 'Nome',
                party_id: 'ID de terceiros',
                country_code: 'Código do país',
                version_url: 'URL de versión',
                emsp: 'EMSP',
                token_a: 'Token A',
                token_b: 'Token B',
                token_c: 'Token C',
                allow_locations_to_be_extracted: 'Permitir que só se extraian localizacións do EMPS',
                allow_receive_location_update:
                    'Permitir recibir actualizacións de localización PUT (posta en marcha inicial) e PATCH (actualización de estado)',
                access_group: 'Grupo de acceso',
                allow_tariff_extraction: 'Incluir Tarifa',
                usagePlan: 'Plan de uso',
            },
        },
    },
    accessGroups: {
        title: 'Grupos de acceso: ##COMPANY_BRAND_NAME## - Plataforma de servizos de eMobility',
        header: 'Grupos de acceso',
        manageAccessGroup: 'Xestionar grupos de acceso',
        label: {
            createdDate: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            enabled: 'Activado',
            disabled: 'Desactivadas',
            name: 'Nome',
            description: 'Descrición',
            access_control_type: 'Tipo de control de acceso',
            allow_public_access: 'Permitir acceso público',
            managed_by_organisation: 'Xestionado pola organización',
            override_tariff: 'Anular tarifa',
            yes: 'Si',
            no: 'Non',
            access_code: 'Código de acceso',
            deleted: ' (Eliminado)',
        },
        button: {
            enable: 'Activar',
            disable: 'Desactivar',
            action: 'Acción',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Activado',
            disabled: 'Desactivadas',
            add: 'Engadir',
            search: 'Buscar',
            reset: 'Restablecer',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            deleted: ' (Eliminado)',
            chargeStation: 'Localizacións de carga',
            yes: 'Si',
            no: 'Non',
            drivers: 'Condutores',
        },
        placeholder: {
            name: 'Nome',
            selectStatus: 'Seleccionar estado',
            allow_public_access: 'Permitir acceso público',
            description: 'Descrición',
            access_control_type: 'Tipo de control de acceso',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            enableConfirmMesage: 'Seguro que quere activar?',
        },
        assign: {
            header: 'Localizacións de carga',
            headerModal: 'Localizacións de carga',
            placeholder: {
                name: 'Introduza o nome',
                address: 'Enderezo',
                tags: 'Seleccionar etiquetas',
                postal_code: 'Código postal',
                power_type: 'Seleccionar tipo de potencia',
            },
            label: {
                add: 'Engadir',
                address: 'Enderezo',
                city: 'Cidade',
                name: 'Nome',
                type: 'Tipo',
                physical_reference: 'Referencia física',
                postcode: 'Código postal',
                action: 'Acción',
                delete: 'Eliminar',
            },
            button: {
                delete: 'Eliminar',
            },
            message: {
                deleteConfirmMesage: 'Seguro que quere eliminar?',
            },
        },
        driverAssign: {
            header: 'Condutores',
            headerModal: 'Condutores',
            placeholder: {
                email: 'Correo electrónico',
                status: 'Estado',
            },
        },
        errors: {
            name: {
                valid: 'Introduza un nome válido',
            },
        },
    },
    accessGroupRequests: {
        title: 'Solicitudes de grupos de acceso: ##COMPANY_BRAND_NAME## - Plataforma de servizos eMobility',
        header: 'Solicitudes de grupos de acceso',
        columns: {
            name: 'Nome',
            email: 'Correo electrónico',
            federated_account_type: 'Tipo de conta federada',
            requested_access_group: 'Grupo de acceso solicitado',
            requested_date: 'Data solicitada',
            driver_status: 'Estado do condutor',
            request_status: 'Estado da solicitude',
            action: 'Acción',
        },
        button: {
            action: 'Acción',
            search: 'Buscar',
            reset: 'Restablecer',
            save: 'Gardar',
            cancel: 'Cancelar',
        },
        label: {
            review_request: 'Solicitude de revisión',
            requested_access_group: 'Grupo de acceso solicitado:',
            approve: 'Aprobar',
            decline: 'Rexeitar',
            enterComments: 'Comentarios',
        },
        placeholder: {
            nameEmail: 'Nome / Correo electrónico',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
            status: 'Seleccionar estado',
            enterComments: 'Introduza os seus comentarios',
        },
        errors: {
            approveReject: 'Aprobe ou rexeite esta solicitude.',
        },
    },
    payByWeb: {
        title: 'Pagar por web: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Pagar por web',
        columns: {
            evse_id: 'ID EVSE',
            status: 'Estado',
            physical_reference: 'Referencia física',
            location_name: 'Nome da localización',
            location_address: 'Enderezo da localización',
            location_city: 'Cidade da localización',
            location_postal_code: 'Código postal da localización',
            pay_by_web_active: 'Pagar por web',
            action: 'Acción',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            enablePayByWeb: 'Activar o pagamento por sitio web',
            disabledPayByWeb: 'Desactivar o pagamento por sitio web',
            submit: 'Enviar',
            cancel: 'Cancelar',
        },
        label: {
            enabled: 'Activar',
            disabled: 'Desactivar',
            manageUniqueCode: 'Xestionar código único',
            uniqueCode: 'Código único',
        },
        message: {
            enableConfirmMesage: 'Seguro que quere activar o pagamento por web para as estacións seleccionadas?',
            disableConfirmMesage: 'Seguro que quere desactivar o pagamento por web para as estacións seleccionadas?',
        },
        placeholder: {
            evse_id: 'ID EVSE',
            status: 'Seleccionar estado',
            physical_reference: 'Referencia física',
            location_name: 'Nome da localización',
            location_address: 'Enderezo da localización',
        },
        errors: {
            unique_code: {
                valid: 'Introduza un código único válido',
            },
        },
    },
    driverDebt: {
        title: 'Débeda do condutor: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Débeda do condutor',
        button: {
            download: 'Descargar',
            strikeOneLetter: 'Carta de 1.ª infracción',
            strikeTwoLetter: 'Carta de 2.ª infracción',
            generateStrikeOneLetters: 'Xerar cartas de 1.ª infracción',
            generateStrikeTwoLetters: 'Xerar cartas de 2.ª infracción',
            runHistory: 'Xerar cartas de aviso - Historial de execución',
            pastLetters: 'Cartas anteriores',
            regenerateLetters: 'Volver xerar cartas',
            refreshPastLetters: 'Actualizar cartas antigas',
        },
        label: {
            pastLetters: 'Cartas anteriores',
            inProgress: '(en curso)',
            noDataFound: 'Non se atoparon datos.',
            dynamicFields: 'Campos dinámicos',
            clickToCopy: '(faga clic para copiar a anotación)',
            driverName: 'Nome do condutor',
            driverDebt: 'Débeda do condutor',
            debtAge: 'Antigüidade da débeda',
            driverEmail: 'Correo electrónico do condutor',
            driverAddress: 'Enderezo do condutor',
            date: 'Data',
            clickToCopyTooltip: 'Faga clic para copiar',
            regenerate: 'Volver xerar',
            regenerateLetters: 'Volver xerar cartas',
            letterTemplate: 'Modelo de carta',
            cancel: 'Cancelar',
            reportGenerationInProgress: '(Xeración de informes en curso)',
            copyDriverIds: 'Faga clic para copiar os ID dos condutores',
        },
        columns: {
            run: 'Nº de execución',
            driverIDs: 'ID de condutor aptos neste punto de execución',
            runTimestamp: 'Marca de hora da execución',
            strikeType: 'Tipo de infracción',
            initiatedByUser: 'Usuario que iniciou a execución',
            regenerate: 'Volver xerar',
            action: 'Acción',
            relatedRun: 'Nº de execución relacionada',
            date: 'Data',
            file: 'Ficheiro',
            templateUsed: 'Modelo utilizado',
            generatedBy: 'Xerado por',
        },
        placeholder: {
            strikeOneLetter: 'Seleccione carta de 1.ª infracción',
            strikeTwoLetter: 'Seleccione carta de 2.ª infracción',
        },
    },
    fleetAccessGroups: {
        title: 'Solicitudes de grupos de acceso: ##COMPANY_BRAND_NAME## - Plataforma de servizos eMobility',
    },
    emailLogs: {
        title: 'Rexistros de correos electrónicos: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Rexistros de correos electrónicos',
        columns: {
            recipient: 'Destinatario',
            subject: 'Asunto',
            deliveryStatus: 'Estado da entrega',
            errorMessage: 'Mensaxe de erro',
            createdDate: 'Data de creación',
        },
        label: {
            viewError: 'Ver erro',
        },
        placeholder: {
            recipient: 'Destinatario',
            subject: 'Asunto',
            deliveryStatus: 'Estado da entrega',
            errorMessage: 'Mensaxe de erro',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
        },
    },
    alerts: {
        title: 'Rexistros de erro de OCPI: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Rexistros de erros de OCPI',
        columns: {
            api: 'url',
            api_call_type: 'Tipo de chamada API',
            api_request_type: 'Tipo de solicitude',
            response_code: 'Código de resposta',
            error_message: 'Mensaxe de erro',
            alert_type: 'Tipo de alerta',
            created_date: 'Data de creación',
            request_body: 'Corpo da solicitude',
            response_body: 'Campo da resposta',
        },
        placeholder: {
            api: 'url',
            alert_type: 'Tipo de alerta',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
        },
        label: {
            viewDetails: 'Ver detalles',
            errorLogDetails: 'Detalles do rexistro de erro de OCPI',
        },
    },
    SubscriptionSetting: {
        title: 'Subscricións Premium: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Subscricións Premium',
        manageSubscription: 'Xestionar subscrición Premium',
        label: {
            subscription_type: 'Tipo de subscrición',
            subscription_amount: 'Importe da subscrición',
            free_subscription_duration: 'Duración da subscrición gratuíta',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activar',
            disabled: 'Desactivar',
            maximum_routing_call: 'Número máximo de chamadas de enrutamento (ó mes)',
            additional_volts_per_kwh: 'Recompensa de voltios adicionais / kWh',
            name: 'Nome',
            description: 'Descrición',
            subscriptionImage: 'Imaxe de subscrición Premium',
            exportSubscribersList: 'Exportar lista de subscritores',
            downloadSubscribersList: 'Descargar lista de subscritores',
        },
        placeholder: {
            subscription_amount: 'Importe da subscrición',
            free_subscription_duration: 'Duración da subscrición gratuíta (días)',
            maximum_routing_call: 'Número máximo de chamadas de enrutamento',
            name: 'Nome',
            status: 'Seleccionar estado',
            subscriptionType: 'Seleccionar tipo de subscrición',
            subscriptionImage: 'Seleccionar imaxe de subscrición Premium',
        },
        button: {
            action: 'Acción',
            disable: 'Desactivar',
            enable: 'Activar',
            edit: 'Editar',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            enableDisable: 'Activar/Desactivar subscrición',
            add: 'Engadir',
            search: 'Buscar',
            reset: 'Restablecer',
        },
        errors: {
            amount: {
                moreThan: 'O importe debe ser superior a 1',
                lessThan: 'O importe debe ser inferior a 100',
                number: 'O importe debe ser un número',
            },
            duration: {
                moreThan: 'A duración debe ser superior a 1',
                lessThan: 'A duración debe ser inferior a 180',
            },
            maxRoutingCall: {
                moreThan: 'O valor do número máximo de chamadas de enrutamento debe ser superior a 1',
                lessThan: 'O valor do número máximo de chamadas de enrutamento debe ser inferior a 1000',
            },
            additionalVolts: {
                lessThan: 'O valor debe ser inferior ou igual a 5',
                number: 'O valor debe ser un número',
            },
        },
        message: {
            enableFromConfig:
                'Para activar unha subscrición Premium, primeiro configure «Activar subscrición Premium» como «Verdadeiro»» en Axustes > Configuracións',
            disableConfirmMessage:
                'Aviso: Ao desactivar a subscrición Premium, cancelaranse todas as renovacións automáticas da conta de condutor asociada. Seguro que quere desactivar?',
            enableConfirmMessage: 'Seguro que quere activar?',
        },
    },
    advertisingDevices: {
        title: 'Dispositivos publicitarios: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Dispositivos publicitarios',
        label: {
            enabled: 'Activado',
            disabled: 'Desactivadas',
            device_name: 'Nome',
            device_id: 'ID do dispositivo',
            postal_code: 'Código postal',
            charge_station: 'Estación de carga',
            screen_size: 'Tamaño da pantalla',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            operational: 'Operativo',
        },
        button: {
            action: 'Acción',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Activar',
            disabled: 'Desactivar',
            add: 'Engadir',
            reset: 'Restablecer',
            search: 'Buscar',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            assignVideos: 'Asignar vídeos',
            yes: 'Si',
            no: 'Non',
            regenerateS3File: 'Volver xerar ficheiro S3',
            mediaTerminalLogs: 'Rexistros de terminais multimedia',
        },
        placeholder: {
            device_name: 'Nome do dispositivo',
            postal_code: 'Código postal',
            charge_station: 'Estación de carga',
            selectStatus: 'Seleccionar estado',
            screen_size: 'Tamaño da pantalla',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
        },
        insert: {
            header: 'Xestionar dispositivo publicitario',
            placeholder: {
                device_name: 'Nome do dispositivo',
                device_id: 'ID do dispositivo',
                charge_station: 'Estación de carga',
                screen_size: 'Tamaño da pantalla',
            },
            label: {
                device_name: 'Nome do dispositivo',
                device_id: 'ID do dispositivo',
                charge_station: 'Estación de carga',
                screen_size: 'Tamaño da pantalla',
            },
            errors: {
                common: 'Produciuse un erro, ténteo de novo.',
                name: {
                    valid: 'Introduza un nome válido',
                },
                device_id: {
                    valid: 'Introduza un ID de dispositivo válido',
                    min: 'O ID do dispositivo debe ter polo menos 6 caracteres',
                },
            },
        },
        assignVideos: {
            header: 'Vídeos',
            headerModal: 'Vídeos',
            label: {
                action: 'Acción',
                delete: 'Eliminar',
            },
            placeholder: {
                file_name: 'Nome do ficheiro',
                description: 'Descrición',
            },
            message: {
                deleteConfirmMesage: 'Seguro que quere eliminar?',
            },
        },
    },
    advertisingVideos: {
        title: 'Vídeos publicitarios: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Vídeos publicitarios',
        label: {
            file_name: 'Nome do ficheiro',
            description: 'Descrición',
            operational_start_date: 'Data de inicio das operacións',
            operational_end_date: 'Data de fin das operacións',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            reviewVideo: 'Revisar vídeo',
            approve: 'Aprobar',
            reject: 'Rexeitar',
            videoUpload: 'Vídeo',
            comments: 'Comentarios',
        },
        button: {
            action: 'Acción',
            edit: 'Editar',
            delete: 'Eliminar',
            enabled: 'Activar',
            disabled: 'Desactivar',
            add: 'Engadir',
            reset: 'Restablecer',
            search: 'Buscar',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
            reviewVideo: 'Revisar vídeo',
            downloadVideo: 'Descargar vídeo',
            assignDevice: 'Asignar dispositivos',
        },
        placeholder: {
            file_name: 'Nome do ficheiro',
            description: 'Descrición',
            start_date: 'Data de inicio das operacións',
            end_date: 'Data de fin das operacións',
            selectStatus: 'Seleccionar estado',
            videoUpload: 'Vídeo',
            enterComments: 'Introduza os seus comentarios',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
        },
        insert: {
            header: 'Xestionar vídeo publicitario',
            placeholder: {
                description: 'Descrición',
                operational_start_date: 'Data de inicio das operacións',
                operational_end_date: 'Data de fin das operacións',
            },
            label: {
                description: 'Descrición',
                operational_start_date: 'Data de inicio das operacións',
                operational_end_date: 'Data de fin das operacións',
            },
        },
        errors: {
            status: {
                message: {
                    selectApprovalOrReject: 'Aprobe ou rexeite esta solicitude.',
                },
            },
            name: {
                valid: 'Introduza un nome válido',
            },
            file_name: {
                fileType: "Pódense cargar ficheiros con extensión '.mp4', '.flv', '.wmv', '.mpeg', '.avi', '.3gp”.",
                uploadError: 'Erro ao cargar o ficheiro de vídeo',
                required: 'O ficheiro de vídeo é obrigatorio',
                fileNameLength: 'Permítese un máximo de 15 caracteres para o nome do ficheiro',
            },
            file_size: 'O tamaño máximo de carga de ficheiros é',
        },
        assignDevices: {
            header: 'Dispositivos',
            headerModal: 'Dispositivos',
            label: {
                action: 'Acción',
                delete: 'Eliminar',
            },
            placeholder: {
                device_name: 'Nome do dispositivo',
                device_id: 'ID do dispositivo',
                status: 'Estado',
            },
            message: {
                deleteConfirmMesage: 'Seguro que quere eliminar?',
            },
        },
    },
    advertisingCredentials: {
        title: 'Credenciais publicitarias: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Credenciais publicitarias',
        manageCredentials: 'Xestionar credenciais publicitarias',
        label: {
            bucket_name: 'Nome do depósito',
            region_name: 'Nome da rexión',
            download_access_key: 'Descargar chave de acceso',
            download_secret_key: 'Descargar chave secreta',
            upload_access_key: 'Cargar chave de acceso',
            upload_secret_key: 'Cargar chave secreta',
            download_info_object_name: 'Descargar nome do obxecto da información',
            upload_path: 'Cargar camiño',
            dialog_password: 'Contrasinal de diálogo',
            expect_bucket_name: 'Esperar nome do depósito',
            expect_region_name: 'Esperar nome da rexión',
            expect_download_access_key: 'Esperar chave de acceso de descarga',
            expect_download_secret_key: 'Esperar chave secreta de descarga',
            version_code: 'Código de versión',
            download_url: 'Descargar URL',
            prompt: 'Preguntar',
            remarks: 'Observacións',
            modified_by: 'Modificado por',
            modified_date: 'Data de modificación',
            status: 'Estado',
            action: 'Acción',
            enabled: 'Activar',
            disabled: 'Desactivar',
        },
        button: {
            action: 'Acción',
            disable: 'Desactivar',
            enable: 'Activar',
            edit: 'Editar',
            back: 'Volver',
            save: 'Gardar',
            cancel: 'Cancelar',
        },
    },
    organisationInvoices: {
        title: 'Facturas da organización: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Facturas da organización',
        label: {
            name: 'Organización',
            invoice_id: 'ID da factura',
            invoice_value: 'Valor da factura',
            invoice_date: 'Data da factura',
            action: 'Acción',
            undo: 'Anular',
            undoPayment: 'Anular pagamento',
            disputed: 'Impugnado',
            adjustAmount: 'Axustar o valor da factura ',
            paid_value: 'Valor pagado',
            outstanding: 'Pendente',
            status: 'Estado',
            comments: 'Comentarios',
            original_value: 'Valor orixinal',
        },
        placeholder: {
            name: 'Nome',
            start_date: 'Data de inicio',
            end_date: 'Data de fin',
            status: 'Estado',
            organisation: 'Seleccionar organización',
        },
        button: {
            search: 'Buscar',
            reset: 'Restablecer',
            action: 'Acción',
            pay: 'Pagar',
            partPay: 'Pagamento de terceiros',
            undo: 'Anular',
            disputed: 'Impugnado',
            adjustValue: 'Axustar o valor da factura',
        },
        errors: {
            amount: {
                moreThan: 'O importe debe ser superior a 0',
                maxValue: 'Acadouse o valor máximo para o importe',
                notZero: 'O importe debe ser maior/menor que 0',
                minValue: 'Acadouse o valor mínimo para o importe',
                number: 'O importe debe ser un número',
            },
            organisation: {
                required: 'Seleccione unha organización',
            },
        },
        message: {
            undoConfirmMessage:
                'Seguro que quere eliminar o valor pagado e establecer o estado desta factura como «Pendente»?',
            disputedConfirmMessage: "Seguro que quere establecer o estado desta factura como «”Impugnada»'?",
        },
        payModal: {
            header: 'Pagar',
            partPayHeader: 'Pagamento de terceiros',
            label: {
                amount: 'Importe',
                date_paid: 'Data de pagamento',
                comments: 'Comentarios',
            },
            placeholder: {
                amount: 'Introduza o importe',
                date_paid: 'Introduza a data de pagamento',
                comments: 'Escribir comentarios',
            },
            button: {
                accept: 'Aceptar',
                send_for_approval: 'Enviar para aprobación',
                cancel: 'Cancelar',
                submit: 'Enviar',
            },
        },
    },
    mediaTerminalLogs: {
        title: 'Rexistros de terminais multimedia: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Rexistros de terminais multimedia',
        label: {
            file_name: 'Nome do ficheiro',
            date_played: 'Data de reprodución',
            play_time: 'Hora de reprodución',
            start_time: 'Hora de inicio',
        },
        placeholder: {
            fileName: 'Nome do ficheiro',
            startDate: 'Data de inicio',
            endDate: 'Data de fin',
        },
    },
    fleetDriverSpendHistory: {
        title: 'Historial de límite de gasto: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Historial de límite de gasto',
        label: {
            enabled: 'Activado',
            disabled: 'Desactivadas',
            name: 'Nome do condutor',
            email: 'Correo electrónico do condutor',
            type: 'Tipo de limiar',
            spend_limit_exceed_date: 'Data de superación de límite de gasto',
            status: 'Estado do condutor',
            action: 'Acción',
            export: 'Exportar',
            onStop: 'En suspensión',
            cancelOnStop: 'Cancelar a suspensión',
        },
        button: {
            disable: 'Desactivar',
            enable: 'Activar',
            search: 'Buscar',
            reset: 'Restablecer',
            yes: 'Si',
            no: 'Non',
            back: 'Volver',
        },
        placeholder: {
            name: 'Nome do condutor',
            email: 'Correo electrónico do condutor',
            status: 'Seleccionar estado do condutor',
            dateFrom: 'Data de superación de límite desde',
            dateTo: 'Data de superación de límite ata',
            type: 'Seleccione o tipo de limiar',
        },
        message: {
            noDataToExport: 'Non hai datos para exportar.',
            cancelOnStopConfirmation: 'Seguro que quere cancelar a suspensión para este condutor?',
        },
    },
    driverDebtorLetters: {
        title: 'Cartas de debedor para condutores: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Cartas de debedor para condutores',
        manageDriverDebtorLetter: 'Xestionar cartas de debedor para condutores',
        label: {
            reportType: 'Tipo de informe',
            defaultLetter: 'Modelo de carta de debedor predefinida',
            content: 'Contido',
            enabled: 'Activado',
            disabled: 'Desactivadas',
            created_date: 'Data de creación',
            status: 'Estado',
            action: 'Acción',
            delete: 'Eliminar',
            dynamicFields: 'Campos dinámicos',
            copyNotation: '(Faga clic para copiar a anotación)',
            clickToCopy: 'Faga clic para copiar',
            driverName: ' â€¢ Nome do condutor',
            driverDebt: 'â€¢ Débeda do condutor',
            debtAge: 'â€¢ Antigüidade da débeda',
            driverEmail: 'â€¢ Correo electrónico do condutor',
            driverAddress: 'â€¢ Enderezo do condutor',
            date: 'â€¢ Data',
            uniqueReference: 'â€¢ Referencia única',
            useStandardTemplate: 'Usar modelo estándar',
        },
        column: {
            defaultLetter: 'Carta predefinida',
        },
        button: {
            setDefaultLetter: 'Establecer como predefinido',
            enable: 'Activar',
            disable: 'Desactivar',
            edit: 'Editar',
            delete: 'Eliminar',
            createDuplicate: 'Crear duplicado',
            save: 'Gardar',
            cancel: 'Cancelar',
            preview: 'Vista previa',
        },
        message: {
            setDefaultConfirmMesage: 'Seguro que quere establecer esta carta de debedor como predefinida?',
            enableConfirmMesage: 'Seguro que quere activar?',
            disableConfirmMesage: 'Seguro que quere desactivar?',
            deleteConfirmMesage: 'Seguro que quere eliminar?',
        },
        error: {
            emptyContent: 'Forneza o contido para previsualizar o modelo da carta',
            common: 'Produciuse un erro ao procesar a súa solicitude. Ténteo de novo máis tarde.',
            supportedDynamicField1: 'Estes campos dinámicos',
            supportedDynamicField2: 'só se admiten para a carta de debedor.',
        },
    },
    driverSubscriptions: {
        title: 'Subscricións Premium de condutores: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        header: 'Subscricións Premium',
        label: {
            subscriptionType: 'Tipo de subscrición',
            subscriptionStartDate: 'Data de inicio da subscrición',
            subscriptionStatus: 'Estado da subscrición',
            renewalOrExpiryDate: 'Data de renovación/caducidade',
            voltsCredited: 'Voltios aboados',
            journeysPlanned: 'Viaxes previstas',
            active: 'Activo',
            cancelled: 'Cancelado',
            action: 'Acción',
            cancel: 'Cancelar',
            cancelSubscription: 'Cancelar subscrición',
            terminate: 'Rematar',
            terminateSubscription: 'Rematar subscrición',
            freeTrial: 'Proba gratuíta',
            name: 'Nome',
            promotion: 'Promoción',
        },
        message: {
            cancelConfirmMessage:
                'Seguro que quere cancelar a subscrición para este usuario? Isto cancelará a próxima renovación automática da subscrición.',
            terminateConfirmMessage:
                'Seguro que quere rematar a subscrición para este usuario? Isto cancelará a próxima renovación automática e deterá todos os beneficios desta subscrición inmediatamente.',
            terminateConfirmMessageWithoutRenew:
                'Seguro que quere rematar a subscrición para este usuario? Isto deterá inmediatamente todos os beneficios desta subscrición.',
        },
    },
    advertisingDropDownDefaultmessage:
        'Introduza un mínimo de 3 caracteres de localizacións para mostrar a lista de estacións',
    rfidcardDropDownDefaultMessage: 'Introduza un mínimo de 3 caracteres para mostrar a lista de condutores/vehículos',
    chargeStationMapDropDownDefaultMessage:
        'Introduza un mínimo de 3 caracteres de estacións de carga para mostrar as estacións de carga',
    startChargePageDropDownDefaultMessage:
        'Introduza caracteres de localizacións para mostrar a lista de localizacións',
    groupGridDropDownDefaultMessage: 'Introduza un mínimo de 3 caracteres para mostrar a lista de condutores/vehículos',
    organisationdashBoardDefaultMessage:
        'Introduza un mínimo de 3 caracteres para mostrar a lista de condutores/vehículos',
    rfidAssigncardDefaultDropDownMessage:
        'Introduza un mínimo de 3 caracteres de enderezo electrónico de condutor para mostrar a lista de condutores',
    limitExceedAddressError: 'Non se puido atopar o enderezo neste momento',
    continueTypingSearch: 'Continuar a escribir para rectificar a busca',
    noFileChosen: 'Non se escolleu ningún ficheiro',
    ChooseFile: 'Escoller ficheiro',
    noOptions: 'Non hai opcións',
    requiredField: 'Ficheiro é un campo obrigatorio',
    removeImage: 'Eliminar imaxe',
    help: 'Axuda',
    editor: {
        bold: 'Negra',
        italic: 'Cursiva',
        underline: 'Subliñado',
        strikeThrough: 'Riscado',
        monospace: 'Monoespazado',
        superscript: 'Superíndice',
        subscript: 'Subíndice',
        blockType: 'Tipo de bloque',
        fontSize: 'Tamaño de letra',
        font: 'Fonte',
        unordered: 'Sen ordenar',
        ordered: 'Ordenado',
        indent: 'Sangría',
        outdent: 'Anulación de sangría',
        left: 'Esquerda',
        right: 'Dereita',
        center: 'Centrar',
        justify: 'Xustificar',
        colorPicker: 'Selector de cor',
        link: 'Ligazón',
        unlink: 'Desligar',
        embedded: 'Incorporado',
        emoji: 'Emoji',
        remove: 'Eliminar',
        undo: 'Anular',
        redo: 'Refacer',
        image: 'Imaxe',
    },
    map: {
        zoomIn: 'Ampliar',
        zoomOut: 'Reducir',
    },
    InstaVolt: '##COMPANY_BRAND_NAME##',
    apply: 'Aplicar',
    cancel: 'Cancelar',
    noDataFound: 'Sentímolo, non se atoparon datos',
    globalService: {
        title: 'Rexistro en Servizo global: ##COMPANY_BRAND_NAME## - Plataforma de servizos de mobilidade eléctrica',
        status: {
            pending:
                'Para comunicarse cos servizos globais, introduza a seguinte información. Prema o botón «»Rexistrarse» para establecer a comunicación.',
            registered:
                'A Plataforma do EMSP pode comunicarse agora mesmo cos servizos globais. Se ten algún problema para comunicarse, introduza a información que se mostra a continuación e faga clic no botón «Volver rexistrarse»».',
        },
        insert: {
            url: 'URL',
            handshakeToken: 'Token de ligazón',
        },
        placeholder: {
            url: 'URL',
            handshakeToken: 'Token de ligazón',
        },
        label: {
            note: 'Nota',
            noteValue:
                'O «Token de ligazón» debe introducirse cada vez que se establece a comunicación cos servizos globais. Para identificar o «Token de ligazón», póñase en contacto co administrador do sistema.',
            rfidSync: 'Sincronización RFID',
        },
        button: {
            register: 'Rexístrese',
            reRegister: 'Volva rexistrarse',
        },
        error: {
            errorWhileCreatingGlobalService: 'Erro ao crear o servizo global.',
            errorWhileUpdatingGlobalService: 'Erro ao actualizar o servizo global.',
        },
        endpointsTable: {
            header: 'Extremo de Servizo Global',
            column: {
                identifer: 'Identificador',
                httpMethod: 'Método Http',
                url: 'Url',
            },
        },
    },
    price_breakdown_details: {
        detailed_breakup: 'Desagregación detallada',
        total_cost: 'Custo total',
        conversion_rate: 'Taxa de conversión',
    },
    SubscriptionImages: {
        title: 'Imaxes de subscrición Premium',
        manageSubscriptionImage: 'Xestionar imaxe de subscrición Premium',
        label: {
            name: 'Nome',
            description: 'Descrición',
            action: 'Acción',
            delete: 'Eliminar',
            image: 'Imaxe',
            language: 'Idioma',
        },
        button: {
            edit: 'Editar',
            search: 'Buscar',
            reset: 'Restablecer',
            add: 'Engadir',
        },
        message: {
            deleteConfirmMesage: 'Seguro que quere eliminar?',
        },
        errors: {
            insertEnglishLanguageImage: 'Cargue unha imaxe para inglés.',
            required: 'A imaxe é obrigatoria.',
        },
    },
    driverPaymentCards: {
        title: 'Tarxetas de pagamento para condutores: InstaVolt - Plataforma de servizos de movilidade eléctrica',
        header: 'Tarxetas de pagamento',
        label: {},
    },
};
